import React, { Component } from 'react';
import Select from 'react-select';
import Creatable from 'react-select/lib/Creatable';
import makeAnimated from 'react-select/lib/animated';
import { Editor } from 'react-draft-wysiwyg';
import {
    EditorState, ContentState,
    convertToRaw,
    Modifier,
    AtomicBlockUtils,
    CharacterMetadata,
    EditorBlock,
    // CompositeDecorator, 
    RichUtils, SelectionState, genKey, ContentBlock,
    // DefaultDraftBlockRenderMap
} from 'draft-js';
import
// Immutable, 
{ List, Repeat } from 'immutable';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import update from 'immutability-helper';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import Session from '../../Utils/Session';
// import InputTag from '../../Components/Input-Tag/Input-Tag';
import HeaderArtigo from '../../Components/Header-Artigo/Header-Artigo';
import moment from 'moment';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import ImagesUpload from '../../Components/Images-Upload/Images-Upload';
import "draft-js/dist/Draft.css";
import "draftail/dist/draftail.css";
import { SingleDatePicker } from 'react-dates';
import Usuario from './../../Utils/Usuario';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import './Article-Preview.scss';
import ArticlePreviewHK from '../../Components/Article-Preview/Article-Preview-HK';
import ArticlePreviewBSMais from '../../Components/Article-Preview/Article-Preview-BSMais';
import CardHighlightDetails from '../../Components/Card-Highlight-Details/Card-Highlight-Details';
import InsertVideo from '../../Components/Insert-Video/Insert-Video';
import InsertCarrossel from '../../Components/Insert-Carrossel/Insert-Carrossel';
import InsertInstagram, { modos as modosInstagram } from '../../Components/Insert-Instagram/Insert-Instagram';
import DivPermission from '../../Components/Div-Permission/Div-Permission';
import ImagemFukyo from '../../Components/Imagem-Fukyo/Imagem-Fukyo';
import Geral from '../../Utils/Geral';
import { stringToSlug } from '../../Utils/StringToSlug';
import InsertPlaylist from '../../Components/Insert-Playlist/Insert-Playlist';
import InsertPodcast from '../../Components/Insert-Podcast/Insert-Podcast';

require('moment/locale/pt-br');

class TagPlayerVideo extends React.Component {

    duracaoFormatada(duracao) {
        if (!duracao) return '';
        const _minutos = Math.floor(duracao / 60);
        const _segundos = duracao - _minutos * 60;
        return `${_minutos}:${_segundos < 10 ? '0' : ''}${_segundos}`;
    }

    render() {
        const { imagem, titulo, programa, duracao, icone } = this.props.blockProps;
        const _legenda = [programa, this.duracaoFormatada(duracao)].filter(item => !!item).join(' • ');
        return (
            <div contentEditable={false} className="div-video-player" style={{ height: 'auto' }}>
                <section contentEditable={false}>
                    <div className="row no-gutters align-items-center">
                        {!!imagem && (
                            <div className="col-auto pr-3">
                                <img src={imagem} alt={titulo} style={{ width: 80, height: 45, objectFit: 'cover', borderRadius: 4 }} />
                            </div>
                        )}
                        <div className="col text-left">
                            <p className="m-0">
                                <i className={icone || "fas fa-play-circle"}></i> {titulo}
                            </p>
                            {!!_legenda && <p className="m-0 font-weight-normal"><small>{_legenda}</small></p>}
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

// Diferente das tags de mídia, o destaque envolve texto do editorial que continua editável: o
// EditorBlock mantém o texto do bloco sob controle do Draft e a div só aplica o estilo.
class TagDestaque extends React.Component {
    render() {
        return (
            <div className="bloco-destaque">
                <EditorBlock {...this.props} />
            </div>
        )
    }
}

class TagPlaylist extends React.Component {
    render() {
        const { imagem, titulo, tipo, itens } = this.props.blockProps;
        const _legenda = [tipo === 'podcast' ? 'Podcasts' : 'Vídeos', !!itens ? `${itens} itens` : ''].filter(item => !!item).join(' • ');
        return (
            <div contentEditable={false} className="div-video-player" style={{ height: 'auto' }}>
                <section contentEditable={false}>
                    <div className="row no-gutters align-items-center">
                        {!!imagem && (
                            <div className="col-auto pr-3">
                                <img src={imagem} alt={titulo} style={{ width: 80, height: 45, objectFit: 'cover', borderRadius: 4 }} />
                            </div>
                        )}
                        <div className="col text-left">
                            <p className="m-0">
                                <i className="fas fa-list"></i> {titulo}
                            </p>
                            <p className="m-0 font-weight-normal"><small>{_legenda}</small></p>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

class TagCarrossel extends React.Component {
    render() {
        const { imagens, blockKey, onEditar } = this.props.blockProps;
        const lista = imagens || [];
        return (
            <div contentEditable={false} className="div-video-player" style={{ height: 'auto' }}>
                <section contentEditable={false}>
                    <div className="row no-gutters align-items-center">
                        <div className="col">
                            <p className="m-0">
                                <i className="fas fa-images"></i> Carrossel de imagens ({lista.length})
                            </p>
                        </div>
                        <div className="col-auto">
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-light"
                                onMouseDown={e => e.stopPropagation()}
                                onClick={e => { e.stopPropagation(); onEditar(blockKey, lista); }}
                            >
                                editar
                            </button>
                        </div>
                    </div>
                    <div className="row no-gutters justify-content-center">
                        {lista.map((img, index) => (
                            <img key={`carrossel-thumb-${index}`} src={img.src} alt={img.alt} style={{ height: 60, margin: 4 }} />
                        ))}
                    </div>
                </section>
            </div>
        )
    }
}

class TagInstagram extends React.Component {
    render() {
        const dados = this.props.blockProps.dados || {};
        const _modo = modosInstagram.find(item => item.value === dados.mode);
        const _legenda = !!_modo ? _modo.curto : dados.mode;
        return (
            <div contentEditable={false} className="div-video-player">
                <section contentEditable={false}>
                    <p className="m-0">
                        <i className="fab fa-instagram"></i> Instagram ({_legenda}): {dados.url}
                    </p>
                </section>
            </div>
        )
    }
}

class ArticleDetails extends Component {

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.defineNomePeriodico = this.defineNomePeriodico.bind(this);
        this.criaTextoHTML = this.criaTextoHTML.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.carregaArtigo = this.carregaArtigo.bind(this);
        this.apiArtigo = this.apiArtigo.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.onChangeInputThumb = this.onChangeInputThumb.bind(this);
        this.salvarAlteracoes = this.salvarAlteracoes.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.atualizaTags = this.atualizaTags.bind(this);
        this.mudaStatusArtigo = this.mudaStatusArtigo.bind(this);
        this.toggleSucessoAlteracao = this.toggleSucessoAlteracao.bind(this);
        this.habilitaSalvar = this.habilitaSalvar.bind(this);
        this.removeEspacosHTML = this.removeEspacosHTML.bind(this);
        this.removeTagHTML = this.removeTagHTML.bind(this);
        this.toggleModalPendencia = this.toggleModalPendencia.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.contadorTexto = this.contadorTexto.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.toggleModalImagem = this.toggleModalImagem.bind(this);
        this.toggleModalExcluirThumb = this.toggleModalExcluirThumb.bind(this);
        this.excluirThumb = this.excluirThumb.bind(this);
        this.toggleModalVideo = this.toggleModalVideo.bind(this);
        this.toggleModalPodcast = this.toggleModalPodcast.bind(this);
        this.toggleModalTutorial = this.toggleModalTutorial.bind(this);
        this.toggleModalPlaylist = this.toggleModalPlaylist.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.togglePub = this.togglePub.bind(this);
        this.salvarAgendamento = this.salvarAgendamento.bind(this);
        this.cancelarAgendamento = this.cancelarAgendamento.bind(this);
        this.addStar = this.addStar.bind(this);
        this.insertImage = this.insertImage.bind(this);
        this.selecionarAba = this.selecionarAba.bind(this);
        this.chamarApiEstatistica = this.chamarApiEstatistica.bind(this);
        this.applySmallTag = this.applySmallTag.bind(this);
        this.applyDestaqueTag = this.applyDestaqueTag.bind(this);
        this.togglePreviewHK = this.togglePreviewHK.bind(this);
        this.exibeDestaque = this.exibeDestaque.bind(this);
        this.scrollToElement = this.scrollToElement.bind(this);
        this.carregaListaProgramasVideos = this.carregaListaProgramasVideos.bind(this);
        this.selecionaVideoPrograma = this.selecionaVideoPrograma.bind(this);
        this.handleModalVideo = this.handleModalVideo.bind(this);
        this.handleModalPodcast = this.handleModalPodcast.bind(this);
        this.handleInsertPodcast = this.handleInsertPodcast.bind(this);
        this._inserirPodcastEmbed = this._inserirPodcastEmbed.bind(this);
        this.handleModalPlaylist = this.handleModalPlaylist.bind(this);
        this.handleInsertPlaylist = this.handleInsertPlaylist.bind(this);
        this.handleInsertVideo = this.handleInsertVideo.bind(this);
        this.toggleModalCarrossel = this.toggleModalCarrossel.bind(this);
        this.handleModalCarrossel = this.handleModalCarrossel.bind(this);
        this.iniciarEdicaoCarrossel = this.iniciarEdicaoCarrossel.bind(this);
        this._substituiBlocoCode = this._substituiBlocoCode.bind(this);
        this.toggleModalInstagram = this.toggleModalInstagram.bind(this);
        this.handleModalInstagram = this.handleModalInstagram.bind(this);
        this._inserirBlocoCode = this._inserirBlocoCode.bind(this);
        this._inserirVideoEmbed = this._inserirVideoEmbed.bind(this);
        this._converteBlocosEspeciais = this._converteBlocosEspeciais.bind(this);
        this._reconverteBlocosEspeciais = this._reconverteBlocosEspeciais.bind(this);
        this._reconverteVideoLegado = this._reconverteVideoLegado.bind(this);
        this._extraiAtributos = this._extraiAtributos.bind(this);
        this._montaAtributosInstagram = this._montaAtributosInstagram.bind(this);
        this._montaAtributosEmbed = this._montaAtributosEmbed.bind(this);
        this._montaAtributosPlaylistEmbed = this._montaAtributosPlaylistEmbed.bind(this);
        this._reconverteEmbed = this._reconverteEmbed.bind(this);
        this._escapaAtributo = this._escapaAtributo.bind(this);
        this._desescapaAtributo = this._desescapaAtributo.bind(this);
        this.addBlock = this.addBlock.bind(this);
        this.blockRendererFn = this.blockRendererFn.bind(this);
        this.replaceAll = this.replaceAll.bind(this);
        this.voltar = this.voltar.bind(this);
        this.handleChangeAutor = this.handleChangeAutor.bind(this);
        this.defaultValueAutor = this.defaultValueAutor.bind(this);
        this.carregaListaTags = this.carregaListaTags.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.pesoManual = this.pesoManual.bind(this);
        this.linkConteudo = this.linkConteudo.bind(this);

        this.state = {
            isLoadingSecoes: true,
            isLoadingArtigo: false,
            isLoadingAlteracoes: false,
            isLoadingStatus: false,
            novoArtigo: this.props.match.params.idArtigo === "novo-artigo",
            temAlteracao: false,
            tags: [],
            modalSucessoNovoArtigo: false,
            habilitaSalvar: false,
            modalPendencia: false,
            pendencias: [],
            hasError: false,
            errorMessage: '',
            openModalImagem: false,
            openModalImagemBSMais: false,
            openModalImagemHub: false,
            openModalImagemThumbBSMais: false,
            openModalImagemThumbHub: false,
            modalExcluirThumb: false,
            thumbExcluir: null,
            openModalVideo: false,
            openModalPodcast: false,
            openModalTutorial: false,
            openModalPlaylist: false,
            openModalCarrossel: false,
            openModalInstagram: false,
            carrosselEmEdicaoBlockKey: null,
            carrosselEmEdicaoImagens: null,
            flagAgendado: false,
            flagCancelado: false,
            verificacaoAcesso: false,
            abaSelecionada: '1',
            flagApiEstatistica: false,
            isLoadingEstatistica: true,
            previaDescricao: '',
            previaTexto: '',
            modalPreviewHK: false,
            dtPubAux: moment(),
            flagDestaqueBSMais: false,
            flagDestaqueHub: false,
            tituloDestaque: '',
            descricaoDestaque: '',
            isLoadingDestaque: false,
            listaProgramasVideos: [],
            isLoadingProgramasVideos: true,
            flagListaProgramasVideos: false,
            isLoadingEpisodiosVideos: true,
            // isLoadingAprovarArtigos: false,
            semEdicao: this.props.match.params.numEdicao === 'sem-edicao',
            listaTags: [],
            listaTagsSelecionadas: [],
            isLoadingListaTags: false,
            pesoManualArtigo: null,
        }

        // Conteúdo do modal de tutorial, voltado ao operador. Referência: Utils/editorTutorial.md
        this.tutorialAvisos = [
            'A mídia entra em um bloco novo, logo abaixo da linha onde o cursor está: clique no parágrafo desejado antes de abrir a janela.',
            'No editor, as mídias aparecem como uma tarja escura com miniatura e título. É só um marcador de posição — o player, o carrossel e o post de verdade aparecem no portal.',
            'Não altere o texto dentro das tarjas: é um código interno e a mídia pode sumir ao salvar. Para trocar, apague o bloco e insira de novo.',
            'Todo artigo precisa de texto escrito. Um artigo só com mídia não é salvo.',
        ];

        this.tutorialRecursos = [
            {
                icone: 'fas fa-image',
                nome: 'Imagem',
                resumo: 'Uma imagem avulsa no meio do texto.',
                passos: [
                    'Escolha a imagem na galeria, envie um arquivo novo ou informe a URL de uma imagem já publicada.',
                    'Para dar uma legenda, escreva o texto abaixo da imagem, selecione-o e clique em "Legenda".',
                ],
            },
            {
                icone: 'fas fa-images',
                nome: 'Carrossel de imagens',
                resumo: 'Várias imagens agrupadas, que o leitor navega no portal.',
                passos: [
                    'Clique em "+ adicionar imagem" e repita para cada imagem do carrossel.',
                    'Reordene com as setas e remova com o "x".',
                ],
            },
            {
                icone: 'fas fa-film',
                nome: 'Vídeo',
                resumo: 'A chamada de um episódio de vídeo já cadastrado. No portal, abre a tela de reprodução.',
                passos: [
                    'Escolha o programa pela capa e depois o episódio.',
                ],
            },
            {
                icone: 'fas fa-podcast',
                nome: 'Podcast',
                resumo: 'O mesmo que o vídeo, para episódios de podcast.',
                passos: [
                    'Escolha o programa e depois o episódio.',
                ],
            },
            {
                icone: 'fas fa-list',
                nome: 'Playlist',
                resumo: 'Uma playlist inteira, de vídeos ou de podcasts.',
                passos: [
                    'Escolha primeiro o tipo: Vídeos ou Podcasts.',
                ],
            },
            {
                icone: 'fab fa-instagram',
                nome: 'Conteúdo do Instagram',
                resumo: 'Post, reel ou perfil do Instagram, em sete formatos de exibição.',
                passos: [
                    'Informe o endereço e escolha o modo: completo, compacto, somente imagem, somente mídia, vídeo com controles nativos, somente link ou perfil.',
                    'Atalho: colar o endereço como texto simples em um parágrafo também funciona, e o portal exibe o post completo.',
                ],
            },
            {
                icone: 'fas fa-external-link-alt',
                nome: 'Conteúdo externo',
                resumo: 'Qualquer conteúdo de fora do BS+: vídeos do YouTube e Vimeo, mapas, formulários. O botão fica na barra padrão, junto do link e do emoji.',
                passos: [
                    'Use sempre o link de incorporação, não o link da página: "youtube.com/embed/ID" em vez de "youtube.com/watch?v=ID", e "player.vimeo.com/video/ID" em vez de "vimeo.com/ID". No YouTube, esse link está em Compartilhar › Incorporar.',
                    'Para conteúdo do próprio BS+, prefira os botões de Vídeo e Podcast: eles já trazem capa, título e duração.',
                ],
            },
            {
                icone: 'fas fa-grip-lines',
                nome: 'Destaque',
                resumo: 'Transforma um parágrafo em uma chamada com texto maior, entre duas divisórias. Para citação, use Blockquote.',
                passos: [
                    'Clique dentro do parágrafo e clique em "Destaque". Clicando de novo, desfaz.',
                    'O texto continua editável, e cada parágrafo equivale a um destaque.',
                ],
            },
        ];

        this.autorOptions = [
            { label: "Redação", value: "Redação" },
            { label: "Colaboração local", value: "Colaboração local" },
            { label: "Colaboração", value: "Colaboraçao" },
            { label: "Departamento de Estudo da BSGI", value: "Departamento de Estudo da BSGI" },
            { label: "Daisaku Ikeda", value: "Daisaku Ikeda" },
            { label: "Dr. Daisaku Ikeda", value: "Dr. Daisaku Ikeda" },
            { label: "Presidente da BSGI", value: "Presidente da BSGI" },
            { label: "Presidente Harada", value: "Presidente Harada" },
            { label: "Miguel Shiratori", value: "Miguel Shiratori" }
        ]

        this.imgToolbar =
            <div onClick={() => this.toggleModalImagem("texto")} className="rdw-image-wrapper" aria-haspopup="true" aria-expanded="false" aria-label="rdw-image-control">
                <div className="rdw-option-wrapper" title="Imagem">
                    <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNzQxIDBILjI2Qy4xMTYgMCAwIC4xMzYgMCAuMzA0djEzLjM5MmMwIC4xNjguMTE2LjMwNC4yNTkuMzA0SDE0Ljc0Yy4xNDMgMCAuMjU5LS4xMzYuMjU5LS4zMDRWLjMwNEMxNSAuMTM2IDE0Ljg4NCAwIDE0Ljc0MSAwem0tLjI1OCAxMy4zOTFILjUxN1YuNjFoMTMuOTY2VjEzLjM5eiIvPjxwYXRoIGQ9Ik00LjEzOCA2LjczOGMuNzk0IDAgMS40NC0uNzYgMS40NC0xLjY5NXMtLjY0Ni0xLjY5NS0xLjQ0LTEuNjk1Yy0uNzk0IDAtMS40NC43Ni0xLjQ0IDEuNjk1IDAgLjkzNC42NDYgMS42OTUgMS40NCAxLjY5NXptMC0yLjc4MWMuNTA5IDAgLjkyMy40ODcuOTIzIDEuMDg2IDAgLjU5OC0uNDE0IDEuMDg2LS45MjMgMS4wODYtLjUwOSAwLS45MjMtLjQ4Ny0uOTIzLTEuMDg2IDAtLjU5OS40MTQtMS4wODYuOTIzLTEuMDg2ek0xLjgxIDEyLjE3NGMuMDYgMCAuMTIyLS4wMjUuMTcxLS4wNzZMNi4yIDcuNzI4bDIuNjY0IDMuMTM0YS4yMzIuMjMyIDAgMCAwIC4zNjYgMCAuMzQzLjM0MyAwIDAgMCAwLS40M0w3Ljk4NyA4Ljk2OWwyLjM3NC0zLjA2IDIuOTEyIDMuMTQyYy4xMDYuMTEzLjI3LjEwNS4zNjYtLjAyYS4zNDMuMzQzIDAgMCAwLS4wMTYtLjQzbC0zLjEwNC0zLjM0N2EuMjQ0LjI0NCAwIDAgMC0uMTg2LS4wOC4yNDUuMjQ1IDAgMCAwLS4xOC4xTDcuNjIyIDguNTM3IDYuMzk0IDcuMDk0YS4yMzIuMjMyIDAgMCAwLS4zNTQtLjAxM2wtNC40IDQuNTZhLjM0My4zNDMgMCAwIDAtLjAyNC40My4yNDMuMjQzIDAgMCAwIC4xOTQuMTAzeiIvPjwvZz48L3N2Zz4=" alt="Imagem" />
                </div>
            </div>;

        this.tagSmallToolbar =
            <div onClick={this.applySmallTag} className="rdw-image-wrapper" aria-haspopup="true" aria-expanded="false" aria-label="rdw-image-control">
                <div className="rdw-option-wrapper" title="Small">
                    <em>Legenda</em>
                </div>
            </div>;

        this.destaqueToolbar =
            <div onClick={this.applyDestaqueTag} className="rdw-image-wrapper" aria-haspopup="true" aria-expanded="false" aria-label="rdw-image-control">
                <div className="rdw-option-wrapper" title="Destaque">
                    <strong>Destaque</strong>
                </div>
            </div>;

        this.styleMap = {
            'SUBSCRIPT': {
                // fontSize: (this.state.styleFrase[this.state.tipoImg].fontSize)/2
                // fontSize: 'smaller'
                fontSize: 12
            },
        };
        this.videoToolbar =
            <div onClick={this.toggleModalVideo} className="rdw-image-wrapper" aria-haspopup="true" aria-expanded="false" aria-label="rdw-image-control">
                <div className="rdw-option-wrapper video" title="Vídeo">
                    <i className="fas fas fa-film"></i>
                </div>
            </div>;
        this.podcastToolbar =
            <div onClick={this.toggleModalPodcast} className="rdw-image-wrapper" aria-haspopup="true" aria-expanded="false" aria-label="rdw-image-control">
                <div className="rdw-option-wrapper video" title="Podcast">
                    <i className="fas fas fa-podcast"></i>
                </div>
            </div>;
        this.playlistToolbar =
            <div onClick={this.toggleModalPlaylist} className="rdw-image-wrapper" aria-haspopup="true" aria-expanded="false" aria-label="rdw-image-control">
                <div className="rdw-option-wrapper video" title="Playlist">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <g fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="2">
                            <path d="M6 6L3 7.732V4.268z" />
                            <path stroke-linecap="round" d="M3 12h18M10 6h11M3 18h18" />
                        </g>
                    </svg>
                </div>
            </div>;

        this.carrosselToolbar =
            <div onClick={this.toggleModalCarrossel} className="rdw-image-wrapper" aria-haspopup="true" aria-expanded="false" aria-label="rdw-image-control">
                <div className="rdw-option-wrapper video" title="Carrossel de imagens">
                    <i className="fas fa-images"></i>
                </div>
            </div>;

        this.instagramToolbar =
            <div onClick={this.toggleModalInstagram} className="rdw-image-wrapper" aria-haspopup="true" aria-expanded="false" aria-label="rdw-image-control">
                <div className="rdw-option-wrapper video" title="Instagram">
                    <i className="fab fa-instagram"></i>
                </div>
            </div>;

        // this.buttonStar =
        //     <div onClick={this.addStar} className="rdw-image-wrapper" aria-haspopup="true" aria-expanded="false" aria-label="rdw-image-control">
        //         <div className="rdw-option-wrapper" title="star">⭐</div>
        //     </div>

        this.toolbar = {
            inline: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
            },
            blockType: {
                inDropdown: true,
                options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote'],
            },
            fontSize: {
                options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
            },
            fontFamily: {
                options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
            },
            list: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['unordered', 'ordered', 'indent', 'outdent'],
            },
            textAlign: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['left', 'center', 'right', 'justify'],
            },
            colorPicker: {
                className: undefined,
                component: undefined,
                popupClassName: undefined,
                colors: ['rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
                    'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
                    'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
                    'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
                    'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
                    'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)',
                    'rgb(0,185,242)',
                    'rgb(0,162,224)',
                    'rgb(0,74,143)',
                    'rgb(0,132,182)',
                    'rgb(0,174,197)',
                    'rgb(0,155,144)',
                    'rgb(114,191,68)',
                    'rgb(191,215,48)',
                    'rgb(249,157,28)',
                    'rgb(244,121,32)',
                    'rgb(239,65,61)',
                    'rgb(237,9,115)',
                    'rgb(240,78,105)',
                    'rgb(242,135,183)',
                    'rgb(169,103,170)',
                    'rgb(171,33,142)',
                    'rgb(100,47,136)'],
            },
            link: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                popupClassName: undefined,
                dropdownClassName: undefined,
                showOpenOptionOnHover: true,
                defaultTargetOption: '_self',
                options: ['link', 'unlink'],
                linkCallback: undefined
            },
            emoji: {
                className: undefined,
                component: undefined,
                popupClassName: undefined,
                emojis: [
                    '😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓',
                    '😛', '😜', '😠', '😇', '😷', '😈', '👻', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈',
                    '🙉', '🙊', '👼', '👮', '🕵', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙇', '🚶', '🏃', '💃',
                    '⛷', '🏂', '🏌', '🏄', '🚣', '🏊', '⛹', '🏋', '🚴', '👫', '💪', '👈', '👉', '👉', '👆', '🖕',
                    '👇', '🖖', '🤘', '🖐', '👌', '👍', '👎', '✊', '👊', '👏', '🙌', '🙏', '🐵', '🐶', '🐇', '🐥',
                    '🐸', '🐌', '🐛', '🐜', '🐝', '🍉', '🍄', '🍔', '🍤', '🍨', '🍪', '🎂', '🍰', '🍾', '🍷', '🍸',
                    '🍺', '🌍', '🚑', '⏰', '🌙', '🌝', '🌞', '⭐', '🌟', '🌠', '🌨', '🌩', '⛄', '🔥', '🎄', '🎈',
                    '🎉', '🎊', '🎁', '🎗', '🏀', '🏈', '🎲', '🔇', '🔈', '📣', '🔔', '🎵', '🎷', '💰', '🖊', '📅',
                    '✅', '❎', '💯',
                ],
            },
            embedded: {
                className: undefined,
                component: undefined,
                popupClassName: undefined,
                embedCallback: undefined,
                defaultSize: {
                    height: 'auto',
                    width: 'auto',
                },
            },
            image: {
                className: "d-none",
                component: undefined,
                popupClassName: undefined,
                urlEnabled: true,
                uploadEnabled: true,
                alignmentEnabled: true,
                uploadCallback: undefined,
                previewImage: false,
                inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                alt: { present: false, mandatory: false },
                defaultSize: {
                    height: 'auto',
                    width: 'auto',
                },
            },
            remove: { className: undefined, component: undefined },
            history: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['undo', 'redo'],
            },
        };



        this.toolbarLegend = {
            inline: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['bold', 'italic', 'underline', 'subscript', 'superscript'],
            },
            blockType: {
                inDropdown: true,
                options: [],
                className: 'd-none'
            },
            fontSize: {
                options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                className: 'd-none',
                component: undefined,
                dropdownClassName: undefined,
            },
            fontFamily: {
                options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'],
                className: 'd-none',
                component: undefined,
                dropdownClassName: undefined,
            },
            list: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: [],
            },
            textAlign: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['center'],
            },
            colorPicker: {
                className: 'd-none',
                component: undefined,
                popupClassName: undefined,
                colors: [],
            },
            link: {
                inDropdown: false,
                className: 'd-none',
                component: undefined,
                popupClassName: undefined,
                dropdownClassName: undefined,
                showOpenOptionOnHover: true,
                defaultTargetOption: '_self',
                options: ['link', 'unlink'],
                linkCallback: undefined
            },
            emoji: {
                className: 'd-none',
                component: undefined,
                popupClassName: undefined,
                emojis: [
                    '😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓',
                    '😛', '😜', '😠', '😇', '😷', '😈', '👻', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈',
                    '🙉', '🙊', '👼', '👮', '🕵', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙇', '🚶', '🏃', '💃',
                    '⛷', '🏂', '🏌', '🏄', '🚣', '🏊', '⛹', '🏋', '🚴', '👫', '💪', '👈', '👉', '👉', '👆', '🖕',
                    '👇', '🖖', '🤘', '🖐', '👌', '👍', '👎', '✊', '👊', '👏', '🙌', '🙏', '🐵', '🐶', '🐇', '🐥',
                    '🐸', '🐌', '🐛', '🐜', '🐝', '🍉', '🍄', '🍔', '🍤', '🍨', '🍪', '🎂', '🍰', '🍾', '🍷', '🍸',
                    '🍺', '🌍', '🚑', '⏰', '🌙', '🌝', '🌞', '⭐', '🌟', '🌠', '🌨', '🌩', '⛄', '🔥', '🎄', '🎈',
                    '🎉', '🎊', '🎁', '🎗', '🏀', '🏈', '🎲', '🔇', '🔈', '📣', '🔔', '🎵', '🎷', '💰', '🖊', '📅',
                    '✅', '❎', '💯',
                ],
            },
            embedded: {
                className: 'd-none',
                component: undefined,
                popupClassName: undefined,
                embedCallback: undefined,
                defaultSize: {
                    height: 'auto',
                    width: 'auto',
                },
            },
            image: {
                className: "d-none",
                component: undefined,
                popupClassName: undefined,
                urlEnabled: true,
                uploadEnabled: true,
                alignmentEnabled: true,
                uploadCallback: undefined,
                previewImage: false,
                inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                alt: { present: false, mandatory: false },
                defaultSize: {
                    height: 'auto',
                    width: 'auto',
                },
            },
            remove: { className: undefined, component: undefined },
            history: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['undo', 'redo'],
            },
        };
        this.styleMap = {
            'SUBSCRIPT': {
                fontSize: 8
            },
        };

        this.Configurations = new Configurations();
    }



    blockRendererFn(contentBlock) {
        const type = contentBlock.getType();

        if (type !== 'code') return;

        const _texto = contentBlock.getText();
        const _partes = _texto.split("@@");
        const _tipo = _partes[1];

        if (_tipo === 'carrossel') {
            let _imagens = [];
            try { _imagens = JSON.parse(decodeURIComponent(_partes[2])); } catch (e) { _imagens = []; }
            return {
                component: TagCarrossel,
                editable: false,
                props: { imagens: _imagens, blockKey: contentBlock.getKey(), onEditar: this.iniciarEdicaoCarrossel }
            };
        }

        if (_tipo === 'instagram') {
            let _dados = {};
            try { _dados = JSON.parse(decodeURIComponent(_partes[2])); } catch (e) { _dados = {}; }
            return {
                component: TagInstagram,
                editable: false,
                props: { dados: _dados }
            };
        }

        if (_tipo === 'video-embed') {
            let _dados = {};
            try { _dados = JSON.parse(decodeURIComponent(_partes[2])); } catch (e) { _dados = {}; }
            return {
                component: TagPlayerVideo,
                editable: false,
                props: {
                    imagem: _dados.image,
                    titulo: _dados.title,
                    programa: _dados.program,
                    duracao: _dados.duration,
                }
            };
        }

        if (_tipo === 'podcast-embed') {
            let _dados = {};
            try { _dados = JSON.parse(decodeURIComponent(_partes[2])); } catch (e) { _dados = {}; }
            return {
                component: TagPlayerVideo,
                editable: false,
                props: {
                    imagem: _dados.image,
                    titulo: _dados.title,
                    programa: _dados.program,
                    duracao: _dados.duration,
                    icone: "fas fa-podcast",
                }
            };
        }

        if (_tipo === 'playlist') {
            let _dados = {};
            try { _dados = JSON.parse(decodeURIComponent(_partes[2])); } catch (e) { _dados = {}; }
            return {
                component: TagPlaylist,
                editable: false,
                props: {
                    imagem: _dados.image,
                    titulo: _dados.title,
                    tipo: _dados.type,
                    itens: _dados.items,
                }
            };
        }

        // vídeo legado: sem marcador de tipo, formato original @@idProg@@idEp@@nomeEp
        const _infosValidas = _partes.length > 3;
        if (_infosValidas) {
            const _nomeVideoEpisodio = _partes[3];
            return {
                component: TagPlayerVideo,
                editable: false,
                props: {
                    titulo: _nomeVideoEpisodio,
                }
            };
        }

        // sem marcador de mídia, o bloco 'code' é um destaque de texto do editorial
        return {
            component: TagDestaque,
            editable: true,
        };
    }


    componentWillUnmount() {
        if (!window.location.href.includes(`conteudo/${this.props.match.params.periodico}`)) Session.clearInfosEdicoes();
    }

    componentWillMount() {
        let _permissoes;
        switch (this.props.match.params.periodico) {
            case "bs":
                _permissoes = [1, 4, 5, 14, 20];
                break;
            case "tc":
                _permissoes = [1, 4, 6, 14, 20];
                break;
            case "rd":
                _permissoes = [1, 4, 7, 14, 20];
                break;
            case "bm":
                _permissoes = [1, 4, 8, 14, 20];
                break;
            case "gpv":
                _permissoes = [1, 4, 5, 14, 20];
                break;
            case "juventude-soka":
                _permissoes = [1, 4, 8, 14, 20];
                break;
            case "liga-monarca":
                _permissoes = [1, 4, 8, 14, 20];
                break;

            default:
                _permissoes = [1];
                break;
        }
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const foundContent = roles.some(r => _permissoes.indexOf(r) >= 0);
        const foundStatistic = roles.some(r => [24].indexOf(r) >= 0);
        if (!foundContent && !foundStatistic) {
            this.props.history.push({ pathname: '/permissao-negada' });
        }
        else {
            this.setState({
                bsMais: this.props.match.params.periodico === "bm",
                artigo: {
                    titulo: '',
                    subTitulo: '',
                    autor: '',
                    pagina: '',
                    categoria: this.props.match.params.periodico.toUpperCase(),
                    edicao: this.props.match.params.numEdicao,
                },
                editorStateDescricao: EditorState.createEmpty(),
                editorStateLegenda: EditorState.createEmpty(),
                editorStateTexto: EditorState.createEmpty(),
                verificacaoAcesso: true,
                permissaoDestaque: roles.some(r => [1, 14, 20].indexOf(r) >= 0),
                permissaoEdicao: foundContent
            })


            this.defineNomePeriodico();
            this.carregaListaTags();


            axios.get(this.Configurations.apiBasePath + `/conteudo/secoes/${this.props.match.params.periodico.toUpperCase()}`).then(response => {
                const _secaoOptions = response.data.secao.map(item => ({
                    label: item.nome, value: item.idSecao
                }))
                this.setState({ secaoOptions: _secaoOptions })
            }).catch(this.handleError).finally(() => this.setState({ isLoadingSecoes: false }));
        }
    }

    componentDidMount() {
        this.setState({ isLoadingArtigo: true });
        if (this.state.verificacaoAcesso) {
            if (!this.state.novoArtigo) {
                this.apiArtigo();
            }
            else {
                axios.get(this.Configurations.apiBasePath + `/conteudo/edicoes/${this.props.match.params.periodico.toUpperCase()}/artigos/${this.props.match.params.numEdicao}`).then(response => {

                    const _edicao = response.data.edicao;
                    this.setState({
                        artigo: {
                            dtPublicacao: (this.state.bsMais || this.state.semEdicao) ? moment().format() : _edicao.dtPublicacao,
                            titulo: '',
                            subTitulo: '',
                            pagina: '',
                            categoria: this.props.match.params.periodico.toUpperCase(),
                            edicao: this.state.bsMais ? 1 : this.state.semEdicao ? '' : this.props.match.params.numEdicao,
                            idTipoAcesso: 3,
                            imagem: '',
                            thumbBSMais: '',
                            thumbHub: '',
                            agendado: false,
                        },
                        habilitaPrevisao: true,
                        secaoSelecionada: null,
                        editorStateDescricao: EditorState.createEmpty(),
                        editorStateLegenda: EditorState.createEmpty(),
                        editorStateTexto: EditorState.createEmpty(),
                        dtPub: moment().format()
                    });
                }).catch(this.handleError).finally(() => this.setState({ isLoadingArtigo: false }));
            };
        }
    }

    carregaArtigo(_artigo) {

        let _editorStateTexto, _editorStateDescricao, _editorStateLegenda;
        const _temDescricao = this.removeEspacosHTML(_artigo.descricao) !== "";
        const _temTexto = this.removeEspacosHTML(_artigo.texto) !== "";
        const _temLegenda = _artigo.legendaCapa ? this.removeEspacosHTML(_artigo.legendaCapa) !== "" : "";


        if (_temDescricao) {

            const contentBlockDescricao = htmlToDraft(_artigo.descricao);
            if (contentBlockDescricao) {
                const contentStateDescricao = ContentState.createFromBlockArray(contentBlockDescricao.contentBlocks);
                _editorStateDescricao = EditorState.createWithContent(contentStateDescricao);
            }

        } else {
            _editorStateDescricao = EditorState.createEmpty();
        }

        if (_temTexto) {
            // ambos os caminhos devolvem os blocos como <pre>@@tipo@@payload</pre>, formato que o
            // blockRendererFn reconhece para exibir o placeholder correspondente.
            let _textoTratado = this._reconverteVideoLegado(_artigo.texto);
            _textoTratado = this._reconverteBlocosEspeciais(_textoTratado);

            const contentBlockTexto = htmlToDraft(_textoTratado);
            if (contentBlockTexto) {
                const contentStateTexto = ContentState.createFromBlockArray(contentBlockTexto.contentBlocks);
                _editorStateTexto = EditorState.createWithContent(contentStateTexto);
            }
        } else {
            _editorStateTexto = EditorState.createEmpty();
        }

        if (_temLegenda) {

            const contentBlockLegenda = htmlToDraft(_artigo.legendaCapa);
            if (contentBlockLegenda) {
                const contentStateLegenda = ContentState.createFromBlockArray(contentBlockLegenda.contentBlocks);
                _editorStateLegenda = EditorState.createWithContent(contentStateLegenda);
            }

        } else {
            _editorStateLegenda = EditorState.createEmpty();
        }

        this.setState({
            editorStateDescricao: _editorStateDescricao,
            editorStateTexto: _editorStateTexto,
            editorStateLegenda: _editorStateLegenda,
        }, () => {
            let _novoHTMLDescricao = this.replaceAll(draftToHtml(convertToRaw(this.state.editorStateDescricao.getCurrentContent())), '<sub>', '<small>');
            _novoHTMLDescricao = this.replaceAll(_novoHTMLDescricao, '</sub>', '</small>');
            let _novoHTMLTexto = this.replaceAll(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent())), '<sub>', '<small>');
            _novoHTMLTexto = this.replaceAll(_novoHTMLTexto, '</sub>', '</small>');
            this.setState({
                // tags: _artigo.tags,
                tags: _artigo.tags.map((item, index) => {
                    return { label: item, value: item }
                }),
                flagAgendado: _artigo.status === "Agendado",
                descricaoString: !!_artigo.descricao ? this.removeTagHTML(_artigo.descricao) : _artigo.descricao,
                artigo: {
                    ..._artigo,
                    descricao: _temDescricao ? this.state.editorStateDescricao.getCurrentContent() : '',
                    texto: _temTexto ? draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent())) : '',
                    imagemBSMais: _artigo.imagemBSMais === null ? '' : _artigo.imagemBSMais,
                    imagemHub: _artigo.imagemHub === null ? '' : _artigo.imagemHub,
                    thumbBSMais: !_artigo.thumbBSMais ? '' : _artigo.thumbBSMais,
                    thumbHub: !_artigo.thumbHub ? '' : _artigo.thumbHub,
                    legendaCapa: _temLegenda ? this.state.editorStateLegenda.getCurrentContent() : '',
                },
                secaoSelecionada: {
                    label: _artigo.secao.nome, value: _artigo.secao.idSecao
                },
                autorSelecionado: !!_artigo.autor ? {
                    label: _artigo.autor
                } : null,
                dtPub: _artigo.dtPublicacao,
                dtPubAux: _artigo.dtPublicacao,
                flagCancelado: _artigo.status !== "Agendado" && _artigo.status !== 'Disponível',
                previaDescricao: this.removeEspacosHTML(draftToHtml(convertToRaw(this.state.editorStateDescricao.getCurrentContent()))) !== "" ?
                    <div dangerouslySetInnerHTML={this.criaTextoHTML(_novoHTMLDescricao)} />
                    :
                    '',
                // TODO: previaTexto usa o HTML "cru" do draftToHtml (blocos <pre>@@tipo@@payload</pre>),
                // sem passar por _converteBlocosEspeciais. Carrossel/Instagram/vídeo aparecem como
                // marcador bruto na prévia em vez de renderizados. Ajustar quando a prévia for revisitada.
                previaTexto: this.removeEspacosHTML(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent()))) !== "" ?
                    <div dangerouslySetInnerHTML={this.criaTextoHTML(_novoHTMLTexto)} />
                    :
                    ''
            }, () => {
                let _descricaoAtual = draftToHtml(convertToRaw(this.state.editorStateDescricao.getCurrentContent()));
                _descricaoAtual = _descricaoAtual.toString();
                _descricaoAtual = _descricaoAtual.replace(/<[^>]*>/g, '').replace(/(\r\n|\n|\r)/gm, "").replace(/&nbsp;/g, '');

                this.setState({
                    isLoadingArtigo: false, habilitaPrevisao: true,
                    flagDestaqueBSMais: this.state.artigo.destaqueBSMais,
                    flagDestaqueHub: this.state.artigo.destaqueHub,
                    tituloDestaqueBSMais: this.state.artigo.destaqueBSMais ? undefined : this.state.artigo.titulo,
                    tituloDestaqueHub: this.state.artigo.destaqueHub ? undefined : this.state.artigo.titulo,
                    descricaoDestaqueBSMais: this.state.artigo.destaqueBSMais ? undefined : _descricaoAtual,
                    descricaoDestaqueHub: this.state.artigo.destaqueHub ? undefined : _descricaoAtual,
                    imagemDestaqueBSMais: this.state.artigo.destaqueBSMais ? undefined : this.state.artigo.imagem,
                    imagemDestaqueHub: this.state.artigo.destaqueHub ? undefined : this.state.artigo.imagem,
                    idDestaqueBSMais: this.state.artigo.idDestaqueBSMais,
                    idDestaqueHub: this.state.artigo.idDestaqueHub,
                    imagemBSMais: this.state.artigo.imagemBSMais ? undefined : this.state.artigo.imagemBSMais,
                    imagemHub: this.state.artigo.imagemHub ? undefined : this.state.artigo.imagemHub,
                    thumbHub: this.state.artigo.thumbHub ? undefined : this.state.artigo.thumbHub,
                    thumbBSMais: this.state.artigo.thumbBSMais ? undefined : this.state.artigo.thumbBSMais,
                    pesoManualArtigo: this.state.artigo.pesoManual

                })
            })
        });
    }

    criaTextoHTML(texto) { return { __html: texto } }

    defineNomePeriodico() {
        let _nomePer;
        switch (this.props.match.params.periodico) {
            case "bs": _nomePer = "Brasil Seikyo"; break;
            case "tc": _nomePer = "Terceira Civilização"; break;
            case "rd": _nomePer = "Revista Dez"; break;
            case "bm": _nomePer = "BS+ App"; break;
            case "gpv": _nomePer = "Guia para a Vitória"; break;
            case "juventude-soka": _nomePer = "Juventude Soka"; break;
            case "liga-monarca": _nomePer = "Liga Monarca"; break;
            default: _nomePer = ""; break;
        }
        this.setState(({ nomePeriodico: _nomePer }))
    }

    handleChange(newValue, actionMeta) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        let _secao;
        switch (actionMeta.action) {
            case "clear": _secao = null; break;
            case "select-option": _secao = { value: newValue.value, label: newValue.label }; break;
            case "create-option": _secao = { label: newValue.label }; break;
            default: _secao = null; break;
        }
        this.setState({ secaoSelecionada: _secao === null ? null : _secao })
    };

    handleChangeAutor(newValue, actionMeta) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        let _autor;
        switch (actionMeta.action) {
            case "clear": _autor = null; break;
            case "select-option": _autor = { value: newValue.value, label: newValue.label }; break;
            case "create-option": _autor = { label: newValue.label }; break;
            default: _autor = null; break;
        }
        this.setState({ autorSelecionado: _autor === null ? null : _autor })
    };

    handleInputChange(inputValue, actionMeta) {
    };

    onEditorStateChange(_editorState, _opcao, flagAddBlock) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({ [_opcao]: _editorState }, () => {
            let _novoHTMLDescricao = this.replaceAll(draftToHtml(convertToRaw(this.state.editorStateDescricao.getCurrentContent())), '<sub>', '<small>');
            _novoHTMLDescricao = this.replaceAll(_novoHTMLDescricao, '</sub>', '</small>');
            let _novoHTMLTexto = this.replaceAll(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent())), '<sub>', '<small>');
            _novoHTMLTexto = this.replaceAll(_novoHTMLTexto, '</sub>', '</small>');
            this.setState({
                previaDescricao: this.removeEspacosHTML(draftToHtml(convertToRaw(this.state.editorStateDescricao.getCurrentContent()))) !== "" ?
                    <div dangerouslySetInnerHTML={this.criaTextoHTML(_novoHTMLDescricao)} />
                    :
                    '',
                // TODO: previaTexto usa o HTML "cru" do draftToHtml (blocos <pre>@@tipo@@payload</pre>),
                // sem passar por _converteBlocosEspeciais. Carrossel/Instagram/vídeo aparecem como
                // marcador bruto na prévia em vez de renderizados. Ajustar quando a prévia for revisitada.
                previaTexto: this.removeEspacosHTML(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent()))) !== "" ?
                    <div dangerouslySetInnerHTML={this.criaTextoHTML(_novoHTMLTexto)} />
                    :
                    ''
            })
            if (flagAddBlock) this.addBlock("div", 'teste DIV', "editorStateTexto");
        });
    };

    onChangeInput(e) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        const _name = e.target.name;
        if (_name !== "idTipoAcesso" && !_name.includes('imagem') && !_name.includes('pesoArtigo')) e.preventDefault();
        if (_name === "imagem-texto") {
            const _src = e.target.value,
                _alt = e.target.alt;
            this.insertImage(_src, _alt)
        }
        if (_name === 'pesoArtigo') {
            this.setState({ pesoManualArtigo: e.target.value });
        }
        else {
            this.setState({ artigo: update(this.state.artigo, { [_name]: { $set: e.target.value } }) })
        }
    }

    // o ImagesUpload monta o name como "imagem" + plataforma, por isso o campo da thumb é informado aqui
    onChangeInputThumb(e, _campo) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({ artigo: update(this.state.artigo, { [_campo]: { $set: e.target.value } }) })
    }

    habilitaSalvar() {
        const _tituloValido = this.state.artigo.titulo.trim() !== '',
            _secaoValida = this.state.secaoSelecionada !== null,
            _textoValido = this.removeEspacosHTML(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent()))) !== "";

        const _infosObrigatorias = [
            { campo: "Título", valido: _tituloValido },
            { campo: "Seção", valido: _secaoValida },
            { campo: "Texto", valido: _textoValido },
        ]

        const _pendencias = _infosObrigatorias.filter(item => !item.valido);

        this.setState({ habilitaSalvar: _tituloValido * _secaoValida * _textoValido }, () => this.salvarAlteracoes(_pendencias))
    }

    salvarAlteracoes(_pend) {
        if (this.state.habilitaSalvar) {
            const _secaoSelecionada = this.state.secaoSelecionada.value ?
                {
                    idSecao: this.state.secaoSelecionada.value,
                    nome: this.state.secaoSelecionada.label
                }
                : {
                    nome: this.state.secaoSelecionada.label
                }

            const _descricaoAtual = draftToHtml(convertToRaw(this.state.editorStateDescricao.getCurrentContent()))
            const _legendaAtual = draftToHtml(convertToRaw(this.state.editorStateLegenda.getCurrentContent()))
            const _textoAtual = draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent()))

            let _textoTratado = this._converteBlocosEspeciais(_textoAtual);

            if (this.props.match.params.periodico === "bm") {
                _textoTratado = this.replaceAll(_textoTratado, `style="float:none;height: ;width: "/>`, `style="float:none;margin:0 auto;display:block;"/>`);
                _textoTratado = this.replaceAll(_textoTratado, `style="float:center;height: ;width: "/>`, `style="float:none;margin:0 auto;display:block;"/>`);
                _textoTratado = this.replaceAll(_textoTratado, `style="float:left;height: ;width: "/>`, `style="float:none;margin:0 auto;display:block;"/>`);
                _textoTratado = this.replaceAll(_textoTratado, `style="float:right;height: ;width: "/>`, `style="float:none;margin:0 auto;display:block;"/>`);
            } else {
                _textoTratado = this.replaceAll(_textoTratado, `style="float:none;height: ;width: "/>`, `style="float:none;margin:0 auto;display:block; width: 100%;"/>`);
                _textoTratado = this.replaceAll(_textoTratado, `style="float:center;height: ;width: "/>`, `style="float:none;margin:0 auto;display:block; width: 100%;"/>`);
                _textoTratado = this.replaceAll(_textoTratado, `style="float:left;height: ;width: "/>`, `style="float:none;margin:0 auto;display:block; width: 100%;"/>`);
                _textoTratado = this.replaceAll(_textoTratado, `style="float:right;height: ;width: "/>`, `style="float:none;margin:0 auto;display:block; width: 100%;"/>`);
            }


            _textoTratado = this.replaceAll(_textoTratado, `frameBorder="0"></iframe>`, `mozallowfullscreen webkitallowfullscreen allowfullscreen frameBorder="0"></iframe>`);

            const _temDescricao = this.removeEspacosHTML(_descricaoAtual) !== "",
                _temTexto = this.removeEspacosHTML(_textoTratado) !== "",
                _temLegenda = this.removeEspacosHTML(_legendaAtual) !== "";


            const _salvarArtigo = {
                ...this.state.artigo,
                descricao: _temDescricao ? _descricaoAtual : '',
                legendaCapa: _temLegenda ? _legendaAtual : '',
                texto: _temTexto ? _textoTratado : '',
                secao: _secaoSelecionada,
                autor: this.state.autorSelecionado ? this.state.autorSelecionado.label : null,
                idTipoAcesso: parseInt(this.state.artigo.idTipoAcesso, 10),
                tags: this.state.tags.map(item => item.label),
                dtPublicacao: this.state.flagAgendado ? this.state.dtPub : this.state.artigo.dtPublicacao,
                agendado: this.state.flagAgendado,
                imagemBSMais: this.state.artigo.imagemBSMais,
                imagemHub: this.state.artigo.imagemHub,
                thumbBSMais: this.state.artigo.thumbBSMais || '',
                thumbHub: this.state.artigo.thumbHub || '',
                imagemAlt: this.state.artigo.imagemAlt,
                metaTitle: this.state.artigo.metaTitle,
                metaDescription: this.state.artigo.metaDescription,
                pesoManual: parseInt(this.state.pesoManualArtigo) || 0
            }
            this.setState({ artigo: _salvarArtigo, isLoadingAlteracoes: true }, () => {
                if (this.state.novoArtigo) {
                    axios.post(this.Configurations.apiBasePath + `/conteudo/artigos`, _salvarArtigo).then(response => {
                        this.toggleSucessoAlteracao();
                    }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
                } else {
                    axios.put(this.Configurations.apiBasePath + `/conteudo/artigos/${this.props.match.params.idArtigo}`, _salvarArtigo).then(response => {
                        this.toggleSucessoAlteracao();
                    }).catch(this.handleError).finally(() => this.setState({ isLoadingAlteracoes: false }));
                }
            })

        } else {
            this.setState({ pendencias: _pend }, () => this.toggleModalPendencia());
        }

    }

    replaceAll(string, search, replace) {
        return string.split(search).join(replace);
    }

    removeTagHTML(strHTML) {
        strHTML = strHTML.toString();
        strHTML = strHTML.replace(/<[^>]*>/g, '').replace(/(\r\n|\n|\r)/gm, "").replace(/&nbsp;/g, '');
        return strHTML
    }

    removeEspacosHTML(_strHTML) {
        if ((_strHTML === null) || (_strHTML === ''))
            return "";
        else
            _strHTML = _strHTML.toString();
        return _strHTML.replace(/<[^>]*>/g, '').replace(/(\r\n|\n|\r)/gm, "").replace(/&nbsp;/g, '');
    }

    contadorTexto(_strHTML) {
        let _palavras, _caracteres;
        if ((_strHTML === null) || (_strHTML === ''))
            return 0;
        else
            _strHTML = _strHTML.toString();
        _caracteres = _strHTML.replace(/<[^>]*>/g, '').replace(/(\r\n|\n|\r)/gm, '').replace(/&nbsp;/g, '');
        _palavras = _strHTML.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').split(/\s/g).filter(item => item !== '');
        return {
            caracteres: _caracteres.length,
            palavras: _palavras.length
        };
    }

    mudaStatusArtigo(_metodo) {
        this.setState({ isLoadingStatus: true });
        axios.post(this.Configurations.apiBasePath + `/conteudo/artigos/${this.props.match.params.idArtigo}/${_metodo}`).then(response => {
            this.setState({ isLoadingStatus: false })
            this.apiArtigo();
        }).catch(this.handleError);
    }

    apiArtigo() {
        this.setState({ isLoadingArtigo: true });
        axios.get(this.Configurations.apiBasePath + `/conteudo/artigos/${this.props.match.params.idArtigo}`).then(response => {
            if (response.data.artigo.categoria.toLowerCase() !== this.props.match.params.periodico) {
                // this.handleError({
                //     response: {
                //         data: {
                //             msg: "Esse artigo não pertence ao periódico selecionado."
                //         }
                //     }
                // })
                this.props.history.push('/')
            }
            else this.carregaArtigo(response.data.artigo)

        }).catch(this.handleError).finally(() => this.setState({ isLoadingArtigo: false }));
    }

    atualizaTags(_tags) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({ tags: _tags })
    }

    toggleSucessoAlteracao() {
        if (this.state.modalSucessoAlteracao) {
            this.setState({ modalSucessoAlteracao: false }, () => {
                window.history.go(-1)
                // const { periodico, numEdicao } = this.props.match.params;
                // if (this.state.bsMais) {
                //     this.props.history.push('/conteudo/bm/artigos');
                // } else {
                //     this.props.history.push(`/conteudo/${periodico}/${numEdicao}`);
                // }
            }
            );
        } else this.setState({ modalSucessoAlteracao: true })
    }

    toggleModalPendencia() {
        this.setState({ modalPendencia: !this.state.modalPendencia })
    }

    handleRadio(e) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleCheck(e) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({ artigo: update(this.state.artigo, { [e.target.name]: { $set: !this.state.artigo[e.target.name] } }) })
    }


    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.msg : !!err.message ? err.message : 'Erro inesperado.' })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    toggleModalImagem(_texto = null, plataforma = "") {
        this.setState({
            ['openModalImagem' + plataforma]: !this.state['openModalImagem' + plataforma]
        }, () => {
            if (this.state.openModalImagem) {
                this.setState({ imgNoTexto: _texto === "texto" })
            } else this.setState({ imgNoTexto: false })
        })
    }

    // _thumb: { campo, nome }
    toggleModalExcluirThumb(_thumb = null) {
        this.setState({ modalExcluirThumb: !this.state.modalExcluirThumb, thumbExcluir: _thumb })
    }

    // a thumb não é excluída na base: o campo é apenas limpo e salvo como string vazia junto com o artigo
    excluirThumb() {
        const _thumb = this.state.thumbExcluir;
        this.setState({ temAlteracao: true, artigo: update(this.state.artigo, { [_thumb.campo]: { $set: '' } }) }, () => this.toggleModalExcluirThumb());
    }

    copyToClipboard(str) {
        const el = document.createElement('textarea');  // Create a <textarea> element
        el.value = str;                                 // Set its value to the string that you want copied
        el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
        el.style.position = 'absolute';
        el.style.left = '-9999px';                      // Move outside the screen to make it invisible
        document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
        const selected =
            document.getSelection().rangeCount > 0        // Check if there is any content selected previously
                ? document.getSelection().getRangeAt(0)     // Store selection if found
                : false;                                    // Mark as false to know no selection existed before
        el.select();                                    // Select the <textarea> content
        document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
        document.body.removeChild(el);                  // Remove the <textarea> element
        if (selected) {                                 // If a selection existed before copying
            document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
            document.getSelection().addRange(selected);   // Restore the original selection
        }
    }

    onDateChange(date) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({ dtPubAux: date })
    }

    togglePub() { this.setState({ modalPub: !this.state.modalPub }) }

    salvarAgendamento() {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({
            flagAgendado: true,
            flagCancelado: false,
            dtPub: this.state.dtPubAux
        }, () => this.togglePub())
    }

    cancelarAgendamento() {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        this.setState({
            flagCancelado: true,
            flagAgendado: false,
            dtPubAux: null,
            dtPub: null
        })
    }

    _outsideRange(day) {
        return day.format() <= moment().format();
    }

    addStar() {
        const contentState = Modifier.replaceText(
            this.state.editorStateTexto.getCurrentContent(),
            this.state.editorStateTexto.getSelection(),
            // '⭐',
            'VídeoPlayer',
            this.state.editorStateTexto.getCurrentInlineStyle(),
        );
        this.onEditorStateChange(EditorState.push(this.state.editorStateTexto, contentState, 'insert-characters'), "editorStateTexto");
    }

    insertImage(_src, _alt) {
        const src = _src;
        const height = "";
        const width = "";
        // const width = "widthimgebs";
        const alt = _alt;
        // const entityData = { src, alt, width };
        const entityData = { src, height, width, alt };
        // if (config.alt.present) {
        //   entityData.alt = alt;
        // }
        const entityKey = this.state.editorStateTexto
            .getCurrentContent()
            .createEntity('IMAGE', 'MUTABLE', entityData)
            .getLastCreatedEntityKey();
        const newEditorState = AtomicBlockUtils.insertAtomicBlock(
            this.state.editorStateTexto,
            entityKey,
            ' ',
        );
        // onChange(newEditorState);
        this.onEditorStateChange(newEditorState, "editorStateTexto")
        // this.doCollapse();
    };

    adicionarDivImgs(_texto) {
        const _novoTexto = _texto
            .replace("<img", `<div class="imagem-lateral-artigo"><img`)
            .replace(`;width: 100%"/>`, `;width: 100%"/></div>`)
        return _novoTexto
    }

    selecionarAba(tab) {
        this.setState({ abaSelecionada: tab })
        if (tab === '2' && this.state.flagApiEstatistica === false) {
            this.chamarApiEstatistica();

        }
    }

    chamarApiEstatistica() {
        this.setState({ isLoadingEstatistica: true });
        axios.get(this.Configurations.apiBasePath + `/conteudo/artigos/${this.props.match.params.idArtigo}/estatistica`)
            .then(response => {
                this.setState({
                    flagApiEstatistica: true,
                    estatisticas: response.data.data
                });
            })
            .catch(this.handleError)
            .finally(() => this.setState({ isLoadingEstatistica: false }));
    }
    applySmallTag() {
        this.onEditorStateChange(RichUtils.toggleInlineStyle(this.state.editorStateTexto, 'SUBSCRIPT'), "editorStateTexto");
    }

    // O bloco 'code' é o canal que sobrevive ao draftToHtml/htmlToDraft como <pre>, e é o mesmo
    // usado pelos marcadores de mídia. Sem marcador @@tipo@@, o bloco vira <destaque> ao salvar.
    applyDestaqueTag() {
        this.onEditorStateChange(RichUtils.toggleBlockType(this.state.editorStateTexto, 'code'), "editorStateTexto");
    }

    togglePreviewHK() {
        this.setState({ modalPreviewHK: !this.state.modalPreviewHK })
    }

    exibeDestaque(plataforma) {
        this.setState({ ['exibeDestaque' + plataforma]: true }, () => this.scrollToElement('informacoesDestaque' + plataforma))
    }

    scrollToElement(id) {
        var element = document.getElementById(id);
        if (!!element) element.scrollIntoView({ block: "end", behavior: "smooth" });
    }

    toggleModalVideo() {
        this.setState({ openModalVideo: !this.state.openModalVideo }, () => {
            if (this.state.openModalVideo && !this.state.flagListaProgramasVideos) this.carregaListaProgramasVideos();
        })
    }

    toggleModalPodcast() {
        this.setState({ openModalPodcast: !this.state.openModalPodcast })
    }

    toggleModalTutorial() {
        this.setState({ openModalTutorial: !this.state.openModalTutorial })
    }

    toggleModalPlaylist() {
        this.setState({ openModalPlaylist: !this.state.openModalPlaylist })
    }

    carregaListaProgramasVideos() {
        this.setState({
            isLoadingProgramasVideos: true
        });
        axios.get(this.Configurations.apiBasePath + `/videos/programas?limite=50`)
            .then(response => {
                this.setState({
                    listaProgramasVideos: response.data.data,
                    flagListaProgramasVideos: true
                });
            })
            .catch(err => {
                this.setState({
                    flagListaProgramasVideos: false
                });
                this.handleError(err);
            })
            .finally(() => this.setState({
                isLoadingProgramasVideos: false
            }));
    }

    selecionaVideoPrograma(idVideoPrograma, pagina = 1) {
        this.setState({ isLoadingEpisodiosVideos: true })
        axios.get(this.Configurations.apiBasePath + `/videos/${idVideoPrograma}/episodios?pagina=${pagina}`)
            .then(response => {
                this.setState({
                    listaEpisodiosVideos: response.data.videosEpisodios,
                    paginacaoEpisodiosVideos: response.data.paginacao,
                });
            })
            .catch(this.handleError)
            .finally(() => this.setState({ isLoadingEpisodiosVideos: false }));
    }

    handleModalVideo({ idProg, idEp, nomeEp, episodio, nomePrograma }) {
        this.toggleModalVideo();
        this.handleInsertVideo({ idProg, idEp, nomeEp, episodio, nomePrograma });
    };

    handleModalPodcast({ idProg, idEpisodio, nomeEpisodio, episodio, nomePrograma }) {
        this.toggleModalPodcast();
        this.handleInsertPodcast({ idProg, idEpisodio, nomeEpisodio, episodio, nomePrograma });
    };

    handleInsertPodcast({ idProg, idEpisodio, nomeEpisodio, episodio, nomePrograma }) {
        const _episodio = episodio || { nome: nomeEpisodio };

        // mesma mecânica do handleInsertVideo: a listagem de episódios pode não trazer a duração,
        // então busca o detalhe do episódio. Se falhar, insere o podcast sem a duração.
        if (_episodio.duracao === undefined || _episodio.duracao === null) {
            axios.get(this.Configurations.apiBasePath + `/podcasts/${idProg}/episodios/${idEpisodio}`)
                .then(response => this._inserirPodcastEmbed({ idProg, idEpisodio, episodio: response.data.data, nomePrograma }))
                .catch(() => this._inserirPodcastEmbed({ idProg, idEpisodio, episodio: _episodio, nomePrograma }));
        }
        else this._inserirPodcastEmbed({ idProg, idEpisodio, episodio: _episodio, nomePrograma });
    };

    // Monta o payload da tag <podcast-embed>, com os mesmos campos da tag de vídeo.
    _inserirPodcastEmbed({ idProg, idEpisodio, episodio, nomePrograma }) {
        const _dados = {
            url: ['https://brasilseikyo.com.br/podcast/programa', idProg, 'episodio', stringToSlug(nomePrograma || ''), idEpisodio].join('/'),
            title: episodio.nome || '',
            program: nomePrograma || '',
            description: episodio.descricao || '',
            image: episodio.imagem || '',
            duration: episodio.duracao || '',
        };

        this._inserirBlocoCode(`@@podcast-embed@@${encodeURIComponent(JSON.stringify(_dados))}`);
    }

    handleModalPlaylist({ tipo, playlist }) {
        this.toggleModalPlaylist();
        this.handleInsertPlaylist({ tipo, playlist });
    };

    // Monta o payload da tag <playlist> a partir da playlist escolhida no modal.
    handleInsertPlaylist({ tipo, playlist }) {
        const _playlist = playlist || {};
        const _dados = {
            id: _playlist.id || '',
            type: tipo,
            title: _playlist.nomePlaylist || '',
            category: _playlist.categoria || '',
            image: _playlist.image || '',
            items: _playlist.quantidadeItens || '',
            url: `https://www.brasilseikyo.com.br/${tipo}/playlists/${_playlist.id}/${stringToSlug(_playlist.nomePlaylist)}`,
            duration: _playlist.totalDuracao || ''
        };

        this._inserirBlocoCode(`@@playlist@@${encodeURIComponent(JSON.stringify(_dados))}`);
    };

    handleInsertVideo({ idProg, idEp, nomeEp, episodio, nomePrograma }) {
        const _episodio = episodio || { idVideoPrograma: idProg, idVideoEpisodio: idEp, nome: nomeEp };

        // a listagem de episódios do modal pode não trazer a duração; nesse caso busca o detalhe do
        // episódio, que sempre a traz. Se a busca falhar, insere o vídeo sem a duração.
        if (_episodio.duracao === undefined || _episodio.duracao === null) {
            axios.get(this.Configurations.apiBasePath + `/videos/${idProg}/episodios/${idEp}`)
                .then(response => this._inserirVideoEmbed(response.data.videosEpisodios[0], nomePrograma))
                .catch(() => this._inserirVideoEmbed(_episodio, nomePrograma));
        }
        else this._inserirVideoEmbed(_episodio, nomePrograma);
    };

    // Monta o payload da tag <video-embed> a partir do episódio escolhido no modal. A url segue o
    // mesmo padrão de links do portal usado em linkConteudo, com o slug do nome do programa.
    _inserirVideoEmbed(_episodio, _nomePrograma) {
        const _dados = {
            url: ['https://brasilseikyo.com.br/videos/programas', _episodio.idVideoPrograma, 'episodio', stringToSlug(_nomePrograma || ''), _episodio.idVideoEpisodio].join('/'),
            title: _episodio.nome || '',
            program: _nomePrograma || '',
            description: _episodio.descricao || '',
            image: _episodio.imagem || '',
            duration: _episodio.duracao || '',
        };

        this._inserirBlocoCode(`@@video-embed@@${encodeURIComponent(JSON.stringify(_dados))}`);
    }

    toggleModalCarrossel() {
        this.setState(prevState => ({ openModalCarrossel: !prevState.openModalCarrossel }), () => {
            if (!this.state.openModalCarrossel) {
                this.setState({ carrosselEmEdicaoBlockKey: null, carrosselEmEdicaoImagens: null });
            }
        });
    }

    toggleModalInstagram() {
        this.setState({ openModalInstagram: !this.state.openModalInstagram });
    }

    iniciarEdicaoCarrossel(blockKey, imagens) {
        this.setState({ carrosselEmEdicaoBlockKey: blockKey, carrosselEmEdicaoImagens: imagens }, () => this.toggleModalCarrossel());
    }

    handleModalCarrossel(imagens) {
        const blockKeyEmEdicao = this.state.carrosselEmEdicaoBlockKey;
        this.toggleModalCarrossel();
        const texto = `@@carrossel@@${encodeURIComponent(JSON.stringify(imagens))}`;
        if (blockKeyEmEdicao) {
            this._substituiBlocoCode(blockKeyEmEdicao, texto);
        } else {
            this._inserirBlocoCode(texto);
        }
    }

    handleModalInstagram(dados) {
        this.toggleModalInstagram();
        this._inserirBlocoCode(`@@instagram@@${encodeURIComponent(JSON.stringify(dados))}`);
    }

    // Insere um novo bloco tipo 'code' no editor, mesma mecânica do handleInsertVideo acima,
    // reaproveitada para carregar o payload (json codificado) do carrossel/instagram.
    _inserirBlocoCode(texto) {
        const { editorStateTexto } = this.state;
        const selectionState = editorStateTexto.getSelection();
        const contentState = editorStateTexto.getCurrentContent();
        const currentBlock = contentState.getBlockForKey(selectionState.getStartKey());
        const currentBlockKey = currentBlock.getKey();
        const blockMap = contentState.getBlockMap();
        const blocksBefore = blockMap.toSeq().takeUntil((v) => (v === currentBlock));
        const blocksAfter = blockMap.toSeq().skipUntil((v) => (v === currentBlock)).rest();
        const newBlockKey = genKey();

        let newBlock = new ContentBlock({
            key: newBlockKey,
            type: 'code',
            text: texto,
            characterList: new List(Repeat(CharacterMetadata.create(), texto.length)),
        });

        let newBlockMap = blocksBefore.concat(
            [[currentBlockKey, currentBlock], [newBlockKey, newBlock]],
            blocksAfter
        ).toOrderedMap();

        let selection = editorStateTexto.getSelection();

        let newContent = contentState.merge({
            blockMap: newBlockMap,
            selectionBefore: selection,
            selectionAfter: selection.merge({
                anchorKey: newBlockKey,
                anchorOffset: 0,
                focusKey: newBlockKey,
                focusOffset: 0,
                isBackward: false,
            }),
        });

        let newEditorState = EditorState.push(editorStateTexto, newContent, 'split-block');

        let newSelection = new SelectionState({
            anchorKey: newBlockKey,
            anchorOffset: 0,
            focusKey: newBlockKey,
            focusOffset: texto.length
        });

        newEditorState = EditorState.forceSelection(newEditorState, newSelection);

        this.onEditorStateChange(newEditorState, "editorStateTexto");
    }

    // Substitui o conteúdo de um bloco 'code' já existente (mesma key), usado ao editar um
    // carrossel/instagram já presente no artigo em vez de inserir um bloco novo.
    _substituiBlocoCode(blockKey, texto) {
        const { editorStateTexto } = this.state;
        const contentState = editorStateTexto.getCurrentContent();
        const blockAntigo = contentState.getBlockForKey(blockKey);

        const blockAtualizado = new ContentBlock({
            key: blockKey,
            type: blockAntigo.getType(),
            text: texto,
            characterList: new List(Repeat(CharacterMetadata.create(), texto.length)),
        });

        const newBlockMap = contentState.getBlockMap().set(blockKey, blockAtualizado);
        const newContent = contentState.merge({ blockMap: newBlockMap });
        const newEditorState = EditorState.push(editorStateTexto, newContent, 'change-block-data');

        this.onEditorStateChange(newEditorState, "editorStateTexto");
    }

    // Converte os blocos <pre>@@tipo@@payload</pre> gerados pelo draftToHtml em suas tags finais
    // (<carrousel>/<instagram>), ANTES do tratamento de vídeo legado logo abaixo em salvarAlteracoes
    // (que assume que todo <pre> remanescente é vídeo). Blocos que não forem carrossel/instagram
    // são devolvidos inalterados para aquele fluxo tratar.
    _converteBlocosEspeciais(html) {
        return html.replace(/<pre>([\s\S]*?)<\/pre>/g, (match, texto) => {
            const partes = texto.split('@@');
            const tipo = partes[1];

            if (tipo === 'carrossel') {
                let imagens = [];
                try { imagens = JSON.parse(decodeURIComponent(partes[2])); } catch (e) { imagens = []; }
                const imgsHtml = imagens.map(img => `<img src="${img.src}" alt="${img.alt || ''}" />`).join('');
                return `<carrousel>${imgsHtml}</carrousel>`;
            }

            if (tipo === 'instagram') {
                let dados = {};
                try { dados = JSON.parse(decodeURIComponent(partes[2])); } catch (e) { dados = {}; }
                return `<instagram ${this._montaAtributosInstagram(dados)}></instagram>`;
            }

            // vídeo e podcast têm o mesmo conjunto de atributos, mudando apenas o nome da tag
            if (tipo === 'video-embed' || tipo === 'podcast-embed') {
                let dados = {};
                try { dados = JSON.parse(decodeURIComponent(partes[2])); } catch (e) { dados = {}; }
                return `<${tipo} ${this._montaAtributosEmbed(dados)}></${tipo}>`;
            }

            if (tipo === 'playlist') {
                let dados = {};
                try { dados = JSON.parse(decodeURIComponent(partes[2])); } catch (e) { dados = {}; }
                return `<playlist ${this._montaAtributosPlaylistEmbed(dados)}></playlist>`;
            }

            // vídeo legado: marcador sem tipo, no formato @@idPrograma@@idEpisodio@@nome. Mantido no
            // formato antigo para não descartar os ids que a tag nova não carrega.
            if (partes.length > 3) {
                return `<video data-video="@@${partes[1]}@@${partes[2]}@@${partes[3]}" data-end="#"></video>`;
            }

            // sem marcador de mídia, o bloco é um destaque de texto. O conteúdo é o texto do
            // editorial com a formatação inline que o redator aplicou, e vai preservado.
            if (this.removeEspacosHTML(texto).trim() !== "") return `<destaque><p>${texto}</p></destaque>`;

            return match;
        });
    }

    _montaAtributosEmbed(dados) {
        const partes = [
            `url="${this._escapaAtributo(dados.url)}"`,
            `title="${this._escapaAtributo(dados.title)}"`,
            `program="${this._escapaAtributo(dados.program)}"`,
            `description="${this._escapaAtributo(dados.description)}"`,
            `image="${this._escapaAtributo(dados.image)}"`,
        ];

        if (dados.duration) partes.push(`duration="${this._escapaAtributo(dados.duration)}"`);

        return partes.join(' ');
    }

    // Negativo do trecho de vídeo/podcast de _converteBlocosEspeciais: os dois têm os mesmos
    // atributos, então a leitura é a mesma, mudando só o nome da tag.
    _reconverteEmbed(html, tagEmbed) {
        const regexEmbed = new RegExp(`<${tagEmbed}\\b([^>]*)>\\s*</${tagEmbed}>`, 'g');
        return html.replace(regexEmbed, (match, attrsStr) => {
            const attrs = this._extraiAtributos(`<${tagEmbed} ${attrsStr}>`);
            const dados = {
                url: this._desescapaAtributo(attrs.url),
                title: this._desescapaAtributo(attrs.title),
                program: this._desescapaAtributo(attrs.program),
                description: this._desescapaAtributo(attrs.description),
                image: this._desescapaAtributo(attrs.image),
                duration: attrs.duration || '',
            };
            return `<pre>@@${tagEmbed}@@${encodeURIComponent(JSON.stringify(dados))}</pre>`;
        });
    }

    _montaAtributosPlaylistEmbed(dados) {
        const partes = [
            `id="${this._escapaAtributo(dados.id)}"`,
            `type="${this._escapaAtributo(dados.type)}"`,
            `title="${this._escapaAtributo(dados.title)}"`,
            `category="${this._escapaAtributo(dados.category)}"`,
            `image="${this._escapaAtributo(dados.image)}"`,
            `url="${this._escapaAtributo(dados.url)}"`,
        ];

        if (dados.items) partes.push(`items="${this._escapaAtributo(dados.items)}"`);

        return partes.join(' ');
    }

    // Título e descrição são digitados pelo redator no cadastro do episódio e podem conter
    // caracteres que quebrariam a leitura dos atributos em _extraiAtributos.
    _escapaAtributo(valor) {
        return (valor === null || valor === undefined ? '' : valor.toString())
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    _desescapaAtributo(valor) {
        return (valor || '')
            .replace(/&quot;/g, '"')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&amp;/g, '&');
    }

    _montaAtributosInstagram(dados) {
        const partes = [`url="${dados.url || ''}"`, `mode="${dados.mode || 'full'}"`];

        if (dados.mode === 'image') {
            if (dados.alt) partes.push(`alt="${dados.alt}"`);
            if (!dados.showLink) partes.push(`show-link="false"`);
        }

        if (dados.mode === 'video') {
            if (dados.videoUrl) partes.push(`video-url="${dados.videoUrl}"`);
            if (dados.controls) partes.push(`controls="true"`);
            if (dados.autoplay) partes.push(`autoplay="true"`);
            if (dados.muted) partes.push(`muted="true"`);
            if (dados.loop) partes.push(`loop="true"`);
            if (dados.preload) partes.push(`preload="${dados.preload}"`);
        }

        return partes.join(' ');
    }

    // Caminho inverso de _converteBlocosEspeciais: ao carregar um artigo existente para edição,
    // reescreve <carrousel>/<instagram> como <pre>@@tipo@@payload</pre> antes do htmlToDraft,
    // para que blockRendererFn reconheça o bloco e volte a exibir o placeholder correspondente.
    _reconverteBlocosEspeciais(html) {
        let _html = this._reconverteEmbed(html, 'video-embed');
        _html = this._reconverteEmbed(_html, 'podcast-embed');

        _html = _html.replace(/<playlist\b([^>]*)>\s*<\/playlist>/g, (match, attrsStr) => {
            const attrs = this._extraiAtributos(`<playlist ${attrsStr}>`);
            const dados = {
                id: attrs.id || '',
                type: attrs.type || '',
                title: this._desescapaAtributo(attrs.title),
                category: this._desescapaAtributo(attrs.category),
                image: this._desescapaAtributo(attrs.image),
                items: attrs.items || '',
                url: this._desescapaAtributo(attrs.url),
            };
            return `<pre>@@playlist@@${encodeURIComponent(JSON.stringify(dados))}</pre>`;
        });

        _html = _html.replace(/<carrousel>([\s\S]*?)<\/carrousel>/g, (match, inner) => {
            const imagens = [];
            const imgTagRegex = /<img\b[^>]*>/g;
            let imgMatch;
            while ((imgMatch = imgTagRegex.exec(inner)) !== null) {
                const attrs = this._extraiAtributos(imgMatch[0]);
                imagens.push({ src: attrs.src || '', alt: attrs.alt || '' });
            }
            return `<pre>@@carrossel@@${encodeURIComponent(JSON.stringify(imagens))}</pre>`;
        });

        _html = _html.replace(/<instagram\b([^>]*)>\s*<\/instagram>/g, (match, attrsStr) => {
            const attrs = this._extraiAtributos(`<instagram ${attrsStr}>`);
            const dados = {
                url: attrs.url || '',
                mode: attrs.mode || 'full',
                alt: attrs.alt || '',
                showLink: attrs['show-link'] !== 'false',
                videoUrl: attrs['video-url'] || '',
                autoplay: attrs.autoplay === 'true',
                muted: attrs.muted === 'true',
                loop: attrs.loop === 'true',
                controls: attrs.controls !== 'false',
                preload: attrs.preload || 'metadata',
            };
            return `<pre>@@instagram@@${encodeURIComponent(JSON.stringify(dados))}</pre>`;
        });

        // cada parágrafo do destaque vira um bloco, e a indentação da tag salva é descartada para
        // não virar quebra de linha dentro do texto.
        _html = _html.replace(/<destaque\b[^>]*>([\s\S]*?)<\/destaque>/g, (match, inner) => {
            const paragrafos = [];
            const paragrafoRegex = /<p\b[^>]*>([\s\S]*?)<\/p>/g;
            let paragrafoMatch;
            while ((paragrafoMatch = paragrafoRegex.exec(inner)) !== null) {
                paragrafos.push(`<pre>${paragrafoMatch[1].replace(/\s+/g, ' ').trim()}</pre>`);
            }
            if (!paragrafos.length) return `<pre>${inner.replace(/\s+/g, ' ').trim()}</pre>`;
            return paragrafos.join('');
        });

        return _html;
    }

    // Artigos salvos antes da tag <video-embed> guardam o vídeo como
    // <video data-video="@@idPrograma@@idEpisodio@@nome" data-end="#"></video>. Devolve esses blocos
    // como marcador, preservando o formato antigo dos dados (o negativo do trecho de vídeo legado
    // em _converteBlocosEspeciais). A tag nova é ignorada aqui por causa do (?!-).
    _reconverteVideoLegado(html) {
        return html.replace(/<video(?!-)[^>]*>[\s\S]*?<\/video>/g, match => {
            const partes = match.split('@@');
            if (partes.length < 4) return match;
            const nome = partes[3].split('"')[0].split('<')[0];
            return `<pre>@@${partes[1]}@@${partes[2]}@@${nome}</pre>`;
        });
    }

    _extraiAtributos(tagHtml) {
        const attrs = {};
        const attrRegex = /([\w-]+)\s*=\s*"([^"]*)"/g;
        let m;
        while ((m = attrRegex.exec(tagHtml)) !== null) {
            attrs[m[1]] = m[2];
        }
        return attrs;
    }

    addBlock() {
        // const { editorStateTexto } = this.state;
        // const selectionState = editorStateTexto.getSelection();
        // const contentState = editorStateTexto.getCurrentContent();
        // const currentBlock = contentState.getBlockForKey(selectionState.getStartKey());
        // const currentBlockKey = currentBlock.getKey();
        // const blockMap = contentState.getBlockMap();
        // const blocksBefore = blockMap.toSeq().takeUntil((v) => (v === currentBlock));
        // const blocksAfter = blockMap.toSeq().skipUntil((v) => (v === currentBlock)).rest();
        // const newBlockKey = genKey();

        // // add new ContentBlock to editor state with appropriate text
        // let newBlock = new ContentBlock({
        //     key: newBlockKey,
        //     type: 'header-six',
        //     text: 'teste',
        //     characterList: new List(Repeat(CharacterMetadata.create(), 1)),
        // });

        // let newBlockMap = blocksBefore.concat(
        //     [[currentBlockKey, currentBlock], [newBlockKey, newBlock]],
        //     blocksAfter
        // ).toOrderedMap();

        // let selection = editorStateTexto.getSelection();

        // let newContent = contentState.merge({
        //     blockMap: newBlockMap,
        //     selectionBefore: selection,
        //     selectionAfter: selection.merge({
        //         anchorKey: newBlockKey,
        //         anchorOffset: 0,
        //         focusKey: newBlockKey,
        //         focusOffset: 0,
        //         isBackward: false,
        //     }),
        // });

        // let newEditorState = EditorState.push(editorStateTexto, newContent, 'split-block');

        // // programmatically apply selection on this text 
        // let newSelection = new SelectionState({
        //     anchorKey: newBlockKey,
        //     anchorOffset: 0,
        //     focusKey: newBlockKey,
        //     focusOffset: 1
        // });

        // newEditorState = EditorState.forceSelection(newEditorState, newSelection);

        // // update our component
        // this.onEditorStateChange(newEditorState, "editorStateTexto");


        if (false) {
            const newEditorState = RichUtils.insertSoftNewline(this.state.editorStateTexto);
            if (newEditorState !== this.state.editorStateTexto) {
                this.onEditorStateChange(newEditorState, "editorStateTexto")
            }
        } else {
            const editorState = this.state.editorStateTexto;
            const currentContent = editorState.getCurrentContent();
            const selection = editorState.getSelection();
            const textWithEntity = Modifier.splitBlock(currentContent, selection);

            this.setState({
                editorStateTexto: EditorState.push(editorState, textWithEntity, "split-block")
            });
        }
    };

    voltar() {
        window.history.go(-1);
    }

    defaultValueAutor() {
        let retorno = null;
        if (this.state.autorSelecionado) {
            const listaFiltradaAutor = this.autorOptions.filter(item => item.label === this.state.autorSelecionado.label)
            const itemEncontrado = listaFiltradaAutor.length > 0;
            if (itemEncontrado) {
                retorno = listaFiltradaAutor;
            } else retorno = this.state.autorSelecionado
        } else retorno = null;
        return retorno;
    }

    carregaListaTags() {
        this.setState({ isLoadingListaTags: true })
        axios.get(this.Configurations.apiBasePath + `/tags`).then(response => {
            const _tagsOptions = response.data.data.map(item => ({
                label: item.nomeTag, value: item.nomeTag
            }))
            this.setState({ listaTags: _tagsOptions })
        }).catch(this.handleError).finally(() => this.setState({ isLoadingListaTags: false }))
    }

    handleSelectChange(e, o) {
        if (!this.state.temAlteracao) this.setState({ temAlteracao: true })
        let _list = this.state.tags;

        switch (o.action) {
            case "remove-value":
                const _index = _list.findIndex(item => item === o.removedValue);
                _list.splice(_index, 1);
                break;
            case "clear":
                _list = [];
                return o;
            default:
                _list.push(o.option);
                break;
        }
        this.setState({ tags: _list });
        return o;
    }

    pesoManual() {
        const pesos = [
            {
                peso: 0,
                nome: 'Não recomendado',
                input: 'peso0'
            },
            {
                peso: 1,
                nome: 'Nível 1',
                input: 'peso1'
            },
            {
                peso: 2,
                nome: 'Nível 2',
                input: 'peso2'
            },
            {
                peso: 3,
                nome: 'Nível 3',
                input: 'peso3'
            },
            {
                peso: 4,
                nome: 'Nível 4',
                input: 'peso4'
            },
            {
                peso: 5,
                nome: 'Nível 5',
                input: 'peso5'
            },
        ];

        return pesos
    }

    linkConteudo() {
        let link;
        switch (this.state.artigo.categoria) {
            case 'GPV': link = ['https://brasilseikyo.com.br/guia-para-vitoria', this.state.artigo.edicao.toString(), stringToSlug(this.state.artigo.titulo), this.props.match.params.idArtigo].join('/'); break;
            case 'BS': link = ['https://brasilseikyo.com.br/home/bs-digital/edicao', this.state.artigo.edicao.toString(), 'artigo', stringToSlug(this.state.artigo.titulo), this.props.match.params.idArtigo].join('/'); break;
            case 'TC': link = ['https://brasilseikyo.com.br/home/terceira-civilizacao/edicao', this.state.artigo.edicao.toString(), 'artigo', stringToSlug(this.state.artigo.titulo), this.props.match.params.idArtigo].join('/'); break;
            case 'RD': link = ['https://brasilseikyo.com.br/home/rdez/edicao', this.state.artigo.edicao.toString(), 'artigo', stringToSlug(this.state.artigo.titulo), this.props.match.params.idArtigo].join('/'); break;
            case 'BM': link = ['https://brasilseikyo.com.br/central-de-noticias/noticia', this.props.match.params.idArtigo, stringToSlug(this.state.artigo.titulo)].join('/'); break;
            case 'JUVENTUDE-SOKA': link = ['https://brasilseikyo.com.br/juventude-soka', this.state.artigo.edicao.toString(), stringToSlug(this.state.artigo.titulo), this.props.match.params.idArtigo].join('/'); break;
            case 'LIGA-MONARCA': link = ['https://brasilseikyo.com.br/liga-monarca', this.state.artigo.edicao.toString(), stringToSlug(this.state.artigo.titulo), this.props.match.params.idArtigo].join('/'); break;

            default: link = ''; break;
        }
        return link;
    }


    render() {
        return (

            <div className="row article-details">
                {!this.state.isLoadingArtigo && this.state.verificacaoAcesso && (
                    <HeaderArtigo
                        salvarAlteracoes={this.habilitaSalvar}
                        artigo={this.state.artigo}
                        mudaStatusArtigo={this.mudaStatusArtigo}
                        temAlteracao={this.state.temAlteracao}
                        novoArtigo={this.state.novoArtigo}
                        isLoadingAlteracoes={this.state.isLoadingAlteracoes}
                        isLoadingArtigo={this.state.isLoadingArtigo}
                        isLoadingStatus={this.state.isLoadingStatus}
                        permissaoEdicao={this.state.permissaoEdicao}

                    />
                )}
                <div className="div-artigo text-center">
                    <Nav tabs>
                        <NavItem className="aba-artigo d-none d-lg-block">
                            <NavLink className={this.state.abaSelecionada === '1' ? 'classe-ativada' : 'classe-inativa'} onClick={() => { this.selecionarAba('1'); }}>
                                Editar artigo
                            </NavLink>
                        </NavItem>
                        {!this.state.novoArtigo && (
                            <NavItem className="aba-estatistica d-none d-lg-block">
                                <NavLink className={this.state.abaSelecionada === '2' ? 'classe-ativada' : 'classe-inativa'} onClick={() => { this.selecionarAba('2'); }}>
                                    Estatísticas do artigo
                                </NavLink>
                            </NavItem>
                        )}
                    </Nav>
                    <TabContent activeTab={this.state.abaSelecionada}>
                        <TabPane tabId="1">
                            <div className="col-12 text-left px-3 py-3">
                                {this.state.isLoadingArtigo || this.state.isLoadingSecoes ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row">
                                        {this.state.bsMais ? (
                                            <div className="col-12 text-center text-lg-left">
                                                <h3 className="d-none d-lg-block">{this.state.novoArtigo ? 'Novo' : 'Editar'} artigo - {this.state.nomePeriodico}</h3>
                                                <h5 className="d-lg-none">{this.state.novoArtigo ? 'Novo' : 'Editar'} artigo</h5>
                                                <h5 className="d-lg-none">{this.state.nomePeriodico}</h5>
                                            </div>
                                        ) : (
                                            <div className="col-12 text-center text-lg-left">
                                                <h3 className="d-none d-lg-block">{this.state.novoArtigo ? 'Novo' : 'Editar'} artigo - {this.state.nomePeriodico} - {this.state.semEdicao ? 'Sem edição' : `Edição ${this.props.match.params.numEdicao} (${moment(this.state.artigo.dtEdicao || this.state.artigo.dtPublicacao).format("DD/MM/YY")})`}</h3>
                                                <h5 className="d-lg-none">{this.state.novoArtigo ? 'Novo' : 'Editar'} artigo</h5>
                                                <h5 className="d-lg-none">{this.props.match.params.periodico.toUpperCase()} - {this.state.semEdicao ? 'Sem edição' : `Edição ${this.props.match.params.numEdicao} (${moment(this.state.artigo.dtEdicao).format("DD/MM/YY")})`}</h5>

                                            </div>
                                        )}

                                        {/* Layout desktop */}
                                        <div className="col-12 d-none d-lg-block">
                                            <div className="row no-gutters">
                                                <div className="col-4 py-3">
                                                    <small><small>(*)</small> informações obrigatórias</small>
                                                </div>
                                                {/* {this.state.permissaoDestaque && !this.state.isLoadingDestaqueBSMais && !this.state.isLoadingDestaqueHub && !this.state.novoArtigo && (
                                                    <DivPermission
                                                        arrayPerm={[1, 20]}
                                                        permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                                    >
                                                        {this.state.permissaoEdicao && (
                                                            <div className="col-8 text-right py-3">
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <div className="row">
                                                                            <div className="col-6 text-center">
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        {this.state.flagDestaqueBSMais && (
                                                                                            <span className="badge badge-verdeBM badge-destaque">Esse item é um destaque BS+</span>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className="col-12">
                                                                                        <button className="mt-3 btn btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("BSMais")}>{this.state.flagDestaqueBSMais ? 'editar destaque' : 'cadastrar como destaque BS+'}</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-6 text-center">
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        {this.state.flagDestaqueHub && (
                                                                                            <span className="badge badge-purple badge-destaque">Esse item é um destaque HUB</span>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className="col-12">
                                                                                        <button className="mt-3 btn btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("Hub")}>{this.state.flagDestaqueHub ? 'editar destaque' : 'cadastrar como destaque HUB'}</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </DivPermission>
                                                )} */}
                                            </div>
                                        </div>
                                        {/* Layout mobile */}
                                        <div className="col-12 d-lg-none">
                                            <div className="row no-gutters">
                                                {/* {this.state.permissaoDestaque && !this.state.isLoadingDestaqueBSMais && !this.state.isLoadingDestaqueHub && !this.state.novoArtigo && (
                                                    <div className="col-12 text-center">
                                                        <div className="row my-3">
                                                            <div className="col-6 text-center">
                                                                <div className="row">
                                                                    {this.state.flagDestaqueBSMais && (
                                                                        <div className="col-12 text-center">
                                                                            <span className="badge badge-verdeBM badge-destaque">Destaque BS+</span>
                                                                        </div>
                                                                    )}
                                                                    <div className="col-12 text-center my-2">
                                                                        <button className="btn btn-sm btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("BSMais")}>{this.state.flagDestaqueBSMais ? 'editar' : 'cadastrar destaque BS+'}</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-6 text-center">
                                                                <div className="row">
                                                                    {this.state.flagDestaqueHub && (
                                                                        <div className="col-12 text-center">
                                                                            <span className="badge badge-purple badge-destaque">Destaque HUB</span>
                                                                        </div>
                                                                    )}
                                                                    <div className="col-12 text-center pl-1 my-2">
                                                                        <button className="btn btn-sm btn-outline-success" type="button" name="cadastrar-destaque" onClick={() => this.exibeDestaque("Hub")}>{this.state.flagDestaqueHub ? 'editar' : 'cadastrar destaque HUB'}</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )} */}
                                                <div className="col-12 py-2">
                                                    <small><small>(*)</small> informações obrigatórias</small>
                                                </div>
                                            </div>
                                        </div>

                                        <fieldset disabled={!this.state.permissaoEdicao}>
                                            <div className="col-12 col-lg-6 py-3">
                                                <label>Título<sup><small>(*)</small></sup></label>
                                                <input name="titulo" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.artigo.titulo} autoComplete="off" />
                                            </div>
                                            <div className="col-12 col-lg-6 py-3">
                                                <label>Subtítulo</label>
                                                <input name="subTitulo" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.artigo.subTitulo} autoComplete="off" />
                                            </div>
                                        </fieldset>


                                        <fieldset disabled={!this.state.permissaoEdicao}>
                                            <div className="col-12 col-lg-5 py-3">
                                                <div className="form-group">
                                                    <label htmlFor="secaoArtigo">Seção<sup><small>(*)</small></sup></label>
                                                    <Creatable
                                                        isDisabled={!this.state.permissaoEdicao}
                                                        id="secaoArtigo"
                                                        placeholder="Selecione uma seção"
                                                        closeMenuOnSelect={true}
                                                        components={makeAnimated()}
                                                        defaultValue={this.state.secaoSelecionada ?
                                                            this.state.secaoOptions && this.state.secaoOptions.filter(item => item.value === this.state.secaoSelecionada.value)
                                                            : null
                                                        }
                                                        name="secaoArtigo"
                                                        options={this.state.secaoOptions}
                                                        onChange={this.handleChange}
                                                        onInputChange={this.handleInputChange}
                                                        isClearable
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-4 py-3">
                                                <div className="form-group">
                                                    <label htmlFor="autor">Autor<sup><small>(*)</small></sup></label>
                                                    <Creatable
                                                        isDisabled={!this.state.permissaoEdicao}
                                                        id="autor"
                                                        placeholder="Selecione um autor"
                                                        closeMenuOnSelect={true}
                                                        components={makeAnimated()}
                                                        defaultValue={this.defaultValueAutor()}
                                                        name="autorSelecionado"
                                                        options={this.autorOptions}
                                                        onChange={this.handleChangeAutor}
                                                        onInputChange={this.handleInputChange}
                                                        isClearable
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-3 col-lg-1 py-3">
                                                <label>Página</label>
                                                <input name="pagina" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.artigo.pagina} autoComplete="off" />
                                            </div>
                                        </fieldset>
                                        <div className="offset-0 offset-lg-1" />
                                        <div className="col-12 py-3">
                                            {this.state.permissaoEdicao && (
                                                <div className="row no-gutters align-items-center">
                                                    <div className="col-12 col-lg-3 text-center text-lg-left">
                                                        <label className="m-0">Dt. Publicação:</label>
                                                        {(this.state.flagCancelado && this.state.artigo.status !== "Disponível") && (
                                                            <span> não agendado</span>
                                                        )}
                                                        {/* {(!this.state.flagCancelado && this.state.artigo.status === "Disponível") && ( */}
                                                        {(!this.state.flagCancelado) && (
                                                            <span> {moment(this.state.dtPubAux).format("DD/MM/YY")}</span>
                                                        )}
                                                    </div>
                                                    {this.state.artigo.status !== "Disponível" && (
                                                        <div className="col-12 col-lg-6">
                                                            <div className="row no-gutters">
                                                                <div className="col-12 py-1 py-lg-0 col-lg-6 text-center text-lg-left">
                                                                    <button onClick={this.togglePub} className="btn btn-outline-info">agendar publicação</button>
                                                                </div>
                                                                <div className="col-12 py-1 py-lg-0 col-lg-6 text-center text-lg-left">
                                                                    <button disabled={this.state.flagCancelado} onClick={this.cancelarAgendamento} className="btn btn-outline-secondary">cancelar agendamento</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <fieldset disabled={!this.state.permissaoEdicao}>
                                            <div className="col-12 col-lg-3 py-3">
                                                <label>Acesso</label>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="idTipoAcesso" id="excl" checked={parseInt(this.state.artigo.idTipoAcesso, 10) === 3} value={3} onChange={this.onChangeInput} />
                                                    <label className="form-check-label" htmlFor="excl">Exclusivo para assinantes</label>
                                                </div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="idTipoAcesso" id="assoc" checked={parseInt(this.state.artigo.idTipoAcesso, 10) === 2} value={2} onChange={this.onChangeInput} />
                                                    <label className="form-check-label" htmlFor="assoc">Aberto para associados</label>
                                                </div>
                                                {/* <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="idTipoAcesso" id="nao-assoc" checked={parseInt(this.state.artigo.idTipoAcesso, 10) === 4} value={4} onChange={this.onChangeInput} />
                                                    <label className="form-check-label" htmlFor="assoc">Aberto para não associados logados</label>
                                                </div> */}
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" name="idTipoAcesso" id="publ" checked={parseInt(this.state.artigo.idTipoAcesso, 10) === 1} value={1} onChange={this.onChangeInput} />
                                                    <label className="form-check-label" htmlFor="publ">Aberto ao público</label>
                                                </div>
                                            </div>

                                            <div className="col-4 col-lg-2 py-3">
                                                <label>Recomendação de artigo</label>
                                                <div className="form-check">
                                                    {this.pesoManual() && this.pesoManual().map(item => (
                                                        <div key={item.input}>
                                                            <input className="form-check-input" type="radio" name="pesoArtigo" id={item.input} checked={parseInt(this.state.pesoManualArtigo) === item.peso} value={item.peso} onChange={this.onChangeInput} />
                                                            <label className="form-check-label" htmlFor={item.input}>{item.nome}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="col-12 col-lg-7 py-3">
                                                <label>Imagem de capa x Thumbnail</label>
                                                <div className="border rounded p-2">
                                                    <small>
                                                        A <strong>imagem de capa</strong> é a imagem que aparece dentro do artigo. A <strong>thumbnail</strong> é opcional e só aparece no feed (na lista de artigos).
                                                        <ul className="mb-0 pl-3">
                                                            <li>Sem thumbnail cadastrada: a imagem de capa aparece no feed e dentro do artigo.</li>
                                                            <li>Com thumbnail cadastrada: a thumbnail aparece no feed e a imagem de capa continua aparecendo dentro do artigo.</li>
                                                        </ul>
                                                    </small>
                                                </div>
                                            </div>

                                        </fieldset>

                                        <fieldset disabled={!this.state.permissaoEdicao}>
                                            <div className="col-12 col-lg-12 py-3">
                                                <div className="row no-gutters text-center">
                                                    <div className="col-3">
                                                        <div className="row">
                                                            <div className="col-12 d-none d-lg-block">
                                                                {this.state.permissaoEdicao && (
                                                                    <button onClick={() => this.toggleModalImagem(null, "BSMais")} className="btn btn-outline-info">imagem de capa BS+</button>
                                                                )}
                                                            </div>
                                                            <div className="col-12 d-lg-none">
                                                                <button onClick={() => this.toggleModalImagem(null, "BSMais")} className="btn btn-sm btn-outline-info">capa BS+</button>
                                                            </div>
                                                            {this.state.artigo.imagemBSMais !== '' && (
                                                                <React.Fragment>
                                                                    <div className="offset-lg-1 col-lg-10 col-12 py-3">
                                                                        <ImagemFukyo className="img img-fluid mx-auto p-2" src={this.state.artigo.imagemBSMais} alt="imagem não encontrada" />
                                                                    </div>
                                                                    <div className="col-12 text-center d-none d-lg-block">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.copyToClipboard(this.state.artigo.imagemBSMais)} className="btn btn-sm btn-outline-secondary">copiar link da imagem</button>
                                                                        )}
                                                                    </div>

                                                                    <div className="col-12 text-center d-lg-none">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.copyToClipboard(this.state.artigo.imagemBSMais)} className="btn btn-sm btn-outline-secondary">copiar link</button>
                                                                        )}
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-3">
                                                        <div className="row">
                                                            <div className="col-12 d-none d-lg-block">
                                                                {this.state.permissaoEdicao && (
                                                                    <button onClick={() => this.toggleModalImagem(null, "Hub")} className="btn btn-outline-info">imagem de capa Hub</button>
                                                                )}
                                                            </div>
                                                            <div className="col-12 d-lg-none">
                                                                <button onClick={() => this.toggleModalImagem(null, "Hub")} className="btn btn-sm btn-outline-info">capa Hub</button>
                                                            </div>
                                                            {this.state.artigo.imagemHub !== '' && (
                                                                <React.Fragment>
                                                                    <div className="offset-lg-1 col-lg-10 col-12 py-3">
                                                                        <ImagemFukyo className="img img-fluid mx-auto p-2" src={this.state.artigo.imagemHub} alt="imagem não encontrada" />
                                                                    </div>
                                                                    <div className="col-12 text-center d-none d-lg-block">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.copyToClipboard(this.state.artigo.imagemHub)} className="btn btn-sm btn-outline-secondary">copiar link da imagem</button>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-12 text-center d-lg-none">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.copyToClipboard(this.state.artigo.imagemHub)} className="btn btn-sm btn-outline-secondary">copiar link</button>
                                                                        )}
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-3">
                                                        <div className="row">
                                                            <div className="col-12 d-none d-lg-block">
                                                                {this.state.permissaoEdicao && (
                                                                    <button onClick={() => this.toggleModalImagem(null, "ThumbBSMais")} className="btn btn-outline-purple">Thumbnail BS+</button>
                                                                )}
                                                            </div>
                                                            <div className="offset-lg-1 col-lg-10 col-12 py-3">
                                                                <ImagemFukyo className="img img-fluid mx-auto p-2" src={this.state.artigo.thumbBSMais} alt="imagem não encontrada" />
                                                            </div>
                                                            {this.state.artigo.thumbBSMais && (
                                                                <React.Fragment>
                                                                    <div className="col-12 text-center d-none d-lg-block">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.copyToClipboard(this.state.artigo.thumbBSMais)} className="btn btn-sm btn-outline-secondary">copiar link da imagem</button>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-12 text-center d-lg-none">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.copyToClipboard(this.state.artigo.thumbBSMais)} className="btn btn-sm btn-outline-secondary">copiar link</button>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-12 text-center pt-2">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.toggleModalExcluirThumb({ campo: "thumbBSMais", nome: "Thumbnail BS+" })} className="btn btn-sm btn-outline-danger">excluir thumbnail</button>
                                                                        )}
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-3">
                                                        <div className="row">
                                                            <div className="col-12 d-none d-lg-block">
                                                                {this.state.permissaoEdicao && (
                                                                    <button onClick={() => this.toggleModalImagem(null, "ThumbHub")} className="btn btn-outline-purple">Thumbnail Hub</button>
                                                                )}
                                                            </div>
                                                            <div className="offset-lg-1 col-lg-10 col-12 py-3">
                                                                <ImagemFukyo className="img img-fluid mx-auto p-2" src={this.state.artigo.thumbHub} alt="imagem não encontrada" />
                                                            </div>
                                                            {!!this.state.artigo.thumbHub && (
                                                                <React.Fragment>
                                                                    <div className="col-12 text-center d-none d-lg-block">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.copyToClipboard(this.state.artigo.thumbHub)} className="btn btn-sm btn-outline-secondary">copiar link da imagem</button>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-12 text-center d-lg-none">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.copyToClipboard(this.state.artigo.thumbHub)} className="btn btn-sm btn-outline-secondary">copiar link</button>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-12 text-center pt-2">
                                                                        {this.state.permissaoEdicao && (
                                                                            <button onClick={() => this.toggleModalExcluirThumb({ campo: "thumbHub", nome: "Thumbnail Hub" })} className="btn btn-sm btn-outline-danger">excluir thumbnail</button>
                                                                        )}
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <div className="col-12 py-3">
                                            <label htmlFor="motivo">Legenda da imagem de capa:</label>
                                            <Editor
                                                editorState={this.state.editorStateLegenda}
                                                wrapperClassName="demo-wrapper"
                                                onEditorStateChange={(editorState) => this.onEditorStateChange(editorState, "editorStateLegenda")}
                                                toolbar={this.toolbarLegend}
                                                toolbarClassName={`custom-toolbar ${!this.state.permissaoEdicao ? "d-none" : ""}`}
                                                editorClassName="custom-editor-legenda border px-3"
                                                handlePastedText={() => false}
                                                customStyleMap={this.styleMap}
                                            />
                                        </div>


                                        <div className="col-12 py-3">
                                            <label htmlFor="motivo">Descrição:</label>
                                            <Editor
                                                readOnly={!this.state.permissaoEdicao}
                                                editorState={this.state.editorStateDescricao}
                                                wrapperClassName="demo-wrapper"
                                                onEditorStateChange={(editorState) => this.onEditorStateChange(editorState, "editorStateDescricao")}
                                                toolbar={this.toolbar}
                                                toolbarClassName={`custom-toolbar ${!this.state.permissaoEdicao ? "d-none" : ""}`}
                                                editorClassName="custom-editor-descricao border px-3"
                                                handlePastedText={() => false}
                                            // plugins={plugins}
                                            />
                                        </div>
                                        <div className="col-6 col-lg-4">
                                            <p>Palavras: {this.contadorTexto(draftToHtml(convertToRaw(this.state.editorStateDescricao.getCurrentContent()))).palavras}</p>
                                        </div>
                                        <div className="col-6 col-lg-4">
                                            <p>Caracteres: {this.contadorTexto(draftToHtml(convertToRaw(this.state.editorStateDescricao.getCurrentContent()))).caracteres}</p>
                                        </div>
                                        <div className="col-12 col-lg-8">
                                            <div className="row no-gutters">
                                                <div className="col-12 py-3">
                                                    <div className="row no-gutters align-items-center">
                                                        <div className="col">
                                                            <label htmlFor="motivo">Texto<sup><small>(*)</small></sup>:</label>
                                                        </div>
                                                        <div className="col-auto">
                                                            <button type="button" className="btn btn-sm btn-outline-info mb-2" onClick={this.toggleModalTutorial}>
                                                                <i className="fas fa-question-circle mr-1"></i> Tutorial
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <Editor
                                                        readOnly={!this.state.permissaoEdicao}
                                                        editorState={this.state.editorStateTexto}
                                                        wrapperClassName="demo-wrapper"
                                                        onEditorStateChange={(editorState) => this.onEditorStateChange(editorState, "editorStateTexto")}
                                                        toolbar={this.toolbar}
                                                        toolbarCustomButtons={[
                                                            // this.toolbar,
                                                            this.imgToolbar,
                                                            this.videoToolbar,
                                                            this.podcastToolbar,
                                                            this.playlistToolbar,
                                                            this.carrosselToolbar,
                                                            this.instagramToolbar,
                                                            this.tagSmallToolbar,
                                                            this.destaqueToolbar
                                                        ]}
                                                        toolbarClassName={`custom-toolbar ${!this.state.permissaoEdicao ? "d-none" : ""}`}
                                                        editorClassName="custom-editor-texto border px-3"
                                                        handlePastedText={() => false}
                                                        customBlockRenderFunc={this.blockRendererFn}
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <p>Palavras: {this.contadorTexto(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent()))).palavras}</p>
                                                </div>
                                                <div className="col-6">
                                                    <p>Caracteres: {this.contadorTexto(draftToHtml(convertToRaw(this.state.editorStateTexto.getCurrentContent()))).caracteres}</p>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.habilitaPrevisao && (
                                            <div className={`col-lg-4 d-none d-lg-block`}>
                                                <div className={`row no-gutters`}>
                                                    <ArticlePreviewBSMais
                                                        imagem={this.state.artigo.imagemBSMais}
                                                        dtPublicacao={this.state.dtPubAux}
                                                        nomeSecao={!!this.state.secaoSelecionada ? this.state.secaoSelecionada.label : '[Nome da Seção]'}
                                                        autor={this.state.artigo.autor}
                                                        titulo={this.state.artigo.titulo}
                                                        previaDescricao={this.state.previaDescricao}
                                                        previaTexto={this.state.previaTexto}
                                                        flagCancelado={this.state.flagCancelado}
                                                        sigla={this.props.match.params.periodico}
                                                    />
                                                    <div className="col-12 pt-3 text-center">
                                                        <button onClick={this.togglePreviewHK} className="btn btn-outline-info">ver prévia HK</button>
                                                    </div>
                                                    {this.props.match.params.idArtigo === 'novo-artigo' ?
                                                        null :
                                                        <div className="col-12 pt-3 text-center">
                                                            <a href={this.linkConteudo()} target='_blank' rel="noopener noreferrer">
                                                                <button className="btn btn-outline-primary">Ver artigo</button>
                                                            </a>
                                                        </div>
                                                    }
                                                </div>

                                            </div>
                                        )}
                                        {this.state.isLoadingListaTags ? (
                                            <div className="col-12 text-center px-3">
                                                <div className="spinner-border text-primary " role="status" />
                                            </div>
                                        ) : (
                                            <div className="col-6 py-3 tags-artigos d-none d-lg-block">
                                                <div className='form-group'>
                                                    <label htmlFor="tags-artigo">Tags</label>
                                                    <Select
                                                        id="tags-artigo"
                                                        placeholder=""
                                                        closeMenuOnSelect={true}
                                                        defaultValue={this.state.tags}
                                                        isMulti
                                                        name="tags"
                                                        onChange={this.handleSelectChange}
                                                        options={this.state.listaTags}
                                                        isDisabled={!this.state.permissaoEdicao}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {/* Mobile */}
                                        {this.state.isLoadingListaTags ? (
                                            <div className="col-12 text-center px-3">
                                                <div className="spinner-border text-primary " role="status" />
                                            </div>
                                        ) : (
                                            <div className="col-12 py-3 text-left tags-podcasts-episodios d-lg-none">
                                                <div className='form-group'>
                                                    <label htmlFor="tags-artigo">Tags</label>
                                                    <Select
                                                        id="tags-artigo"
                                                        placeholder=""
                                                        closeMenuOnSelect={true}
                                                        defaultValue={this.state.tags}
                                                        isMulti
                                                        name="tags"
                                                        onChange={this.handleSelectChange}
                                                        options={this.state.listaTags}
                                                        isDisabled={!this.state.permissaoEdicao}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div className="col-12 text-left">
                                            <label>Imagem alt</label>
                                            <input disabled={!this.state.permissaoEdicao} name="imagemAlt" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.artigo.imagemAlt} autoComplete="off" />
                                        </div>
                                        <div className="col-12 text-left mt-3">
                                            <label>Meta title</label>
                                            <input disabled={!this.state.permissaoEdicao} name="metaTitle" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.artigo.metaTitle} autoComplete="off" />
                                        </div>
                                        <div className="col-12 text-left mt-3">
                                            <label>Meta description</label>
                                            <input disabled={!this.state.permissaoEdicao} name="metaDescription" type="text" className="form-control" onChange={this.onChangeInput} value={this.state.artigo.metaDescription} autoComplete="off" />
                                        </div>
                                    </div>
                                )}
                            </div>
                            {this.state.permissaoDestaque && this.state.exibeDestaqueBSMais && (
                                <DivPermission
                                    arrayPerm={[1, 20]}
                                    permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                >
                                    <div className="col-12">
                                        <div className="row mt-5 informacoes-destaque" id="informacoesDestaqueBSMais">
                                            <CardHighlightDetails
                                                tipoDestaque={2}
                                                plataforma={1}
                                                toggleImagem={this.toggleModalImagemDestaque}
                                                idDestaque={this.state.idDestaqueBSMais}
                                                match={this.props.match}
                                                sigla={this.props.match.params.periodico}
                                                itemConteudo={{ ...this.state.artigo, descricao: this.state.descricaoString }}
                                                apiConteudo={this.apiArtigo}
                                                flagDestaque={this.state.flagDestaqueBSMais}
                                            />
                                        </div>
                                    </div>
                                </DivPermission>
                            )}
                            {this.state.permissaoDestaque && this.state.exibeDestaqueHub && (
                                <DivPermission
                                    arrayPerm={[1, 20]}
                                    permUser={Usuario.getLoggedUser.permissoes.map(item => item.numero)}
                                >
                                    <div className="col-12">
                                        <div className="row mt-5 informacoes-destaque" id="informacoesDestaqueHub">
                                            <CardHighlightDetails
                                                tipoDestaque={2}
                                                plataforma={2}
                                                toggleImagem={this.toggleModalImagemDestaque}
                                                idDestaque={this.state.idDestaqueHub}
                                                match={this.props.match}
                                                sigla={this.props.match.params.periodico}
                                                itemConteudo={{ ...this.state.artigo, descricao: this.state.descricaoString }}
                                                apiConteudo={this.apiArtigo}
                                                flagDestaque={this.state.flagDestaqueHub}
                                            />
                                        </div>
                                    </div>
                                </DivPermission>
                            )}
                        </TabPane>
                        <TabPane tabId="2">
                            <div className="col-12 px-3 py-3">
                                <div className="row">
                                    <div className="col-12 text-lg-left">
                                        <h3 className="d-none d-lg-block">Estatísticas do artigo - {this.state.nomePeriodico} - {this.state.semEdicao ? 'Sem edição' : `Ed. ${this.props.match.params.numEdicao}`} ({moment(this.state.artigo.dtEdicao).format("DD/MM/YYYY")})</h3>
                                    </div>
                                </div>
                            </div>
                            {this.state.isLoadingEstatistica ? (
                                <div className="col-12 text-center px-3">
                                    <div className="spinner-border text-primary " role="status" />
                                </div>
                            ) : (
                                <div className="col-12 my-4">
                                    <div className="card">
                                        <div className="card-header">
                                            <strong>Resumo</strong>
                                        </div>
                                        <div className="card-body">
                                            {/* <Loading show={this.state.isLoading} /> */}
                                            <div className="row mb-4">
                                                <div className="col-12">
                                                    <div className="row text-center">
                                                        <div className="col-12 border-bottom pb-2">
                                                            <strong>Visualizações</strong>
                                                        </div>
                                                        <div className="col-12 pt-2">
                                                            <div className="row text-center">
                                                                <div className="col">
                                                                    <span className="featured-number">{this.state.estatisticas.qtdMembrosLeram}</span><br />
                                                                    <span>{this.state.estatisticas.qtdMembrosLeram > 1 ? 'Membros' : 'Membro'}</span>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mb-4 px-6">
                                                <div className="col-5">
                                                    <div className="row">
                                                        <div className="col-12 text-center border-bottom pb-2">
                                                            <strong>Coordenadorias</strong>
                                                        </div>
                                                        <div className="col-12 pt-2">

                                                            <table className="table table-borderless table-sm">
                                                                <tbody>
                                                                    {this.state.estatisticas.qtdLidosCoordenadoria.map((coord, index) => {
                                                                        return (<tr key={index}>
                                                                            <td className="text-left">
                                                                                <strong className="text-uppercase">{coord.coordenadoria}: </strong>
                                                                            </td>
                                                                            <td className="text-right">{coord.qtdReproducao} <small>({Geral.validarNumero(Math.round(coord.qtdReproducao / this.state.estatisticas.qtdLidos * 100))}%)</small></td>
                                                                        </tr>)
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="offset-2 col-5">
                                                    <div className="row">
                                                        <div className="col-12 text-center border-bottom pb-2">
                                                            <strong>Divisão</strong>
                                                        </div>
                                                        <div className="col-12 pt-2">

                                                            <table className="table table-borderless table-sm">
                                                                <tbody>
                                                                    {this.state.estatisticas.qtdLidosDivisao.map((divisao, index) => {
                                                                        return (<tr key={index}>
                                                                            <td className="text-left">
                                                                                <strong className="">{divisao.divisao}: </strong>
                                                                            </td>
                                                                            <td className="text-right">{divisao.qtdReproducao} <small>({Geral.validarNumero(Math.round(divisao.qtdReproducao / this.state.estatisticas.qtdLidos * 100))}%)</small></td>
                                                                        </tr>)
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-5">
                                                    <div className="row">
                                                        <div className="col-12 text-center border-bottom pb-2">
                                                            <strong>Função</strong>
                                                        </div>
                                                        <div className="col-12 pt-2">

                                                            <table className="table table-borderless table-sm">
                                                                <tbody>
                                                                    {this.state.estatisticas.qtdLidosFuncao.map((func, index) => {
                                                                        return (<tr key={index}>
                                                                            <td className="text-left">
                                                                                <strong className="">{func.funcao}: </strong>
                                                                            </td>
                                                                            <td className="text-right">{func.qtdReproducao} <small>({Geral.validarNumero(Math.round(func.qtdReproducao / this.state.estatisticas.qtdLidos * 100))}%)</small></td>
                                                                        </tr>)
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="offset-2 col-5">
                                                    <div className="row">
                                                        <div className="col-12 text-center border-bottom pb-2">
                                                            <strong>Idade</strong>
                                                        </div>
                                                        <div className="col-12 pt-2">

                                                            <table className="table table-borderless table-sm">
                                                                <tbody>
                                                                    {this.state.estatisticas.qtdLidosPorIdade.map((idade, index) => {
                                                                        return (<tr key={index}>
                                                                            <td className="text-left">
                                                                                <strong className="">{idade.idade}: </strong>
                                                                            </td>
                                                                            <td className="text-right">{idade.qtdReproducao} <small> ({Geral.validarNumero(Math.round(idade.qtdReproducao / this.state.estatisticas.qtdLidos * 100))}%)</small></td>
                                                                        </tr>)
                                                                    })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </TabPane>
                    </TabContent>
                </div >

                {/* returnFocusAfterClose desligado: ao fechar, o reactstrap devolve o foco para o
                    elemento ativo de quando o modal abriu — a área de texto do editor, já que a barra
                    de ferramentas cancela o mousedown. Esse focus() sem preventScroll faz o container
                    do editor rolar para o topo, perdendo a posição do redator. */}
                <Modal className="modal-upload-imagem" size="lg" isOpen={this.state.openModalImagem} toggle={this.toggleModalImagem} returnFocusAfterClose={false}>
                    <ModalHeader toggle={this.toggleModalImagem}>
                        Upload de imagem
                    </ModalHeader>
                    <ModalBody>
                        <ImagesUpload
                            toggle={this.toggleModalImagem}
                            onChangeInput={this.onChangeInput}
                            imgNoTexto={this.state.imgNoTexto}
                            alteracao={this.state.temAlteracao}
                            realizaBusca={!!this.state.artigo.imagem}
                            urlImagemBusca={this.state.artigo.imagem}
                        />
                    </ModalBody>
                </Modal>

                <Modal className="modal-upload-imagem" size="lg" isOpen={this.state.openModalImagemBSMais} toggle={() => this.toggleModalImagem(null, "BSMais")}>
                    <ModalHeader toggle={() => this.toggleModalImagem(null, "BSMais")}>
                        Upload de imagem - BS+
                    </ModalHeader>
                    <ModalBody>
                        <ImagesUpload
                            plataforma="BSMais"
                            toggle={this.toggleModalImagem}
                            onChangeInput={this.onChangeInput}
                            imgNoTexto={false}
                            alteracao={this.state.temAlteracao}
                            realizaBusca={!!this.state.artigo.imagemBSMais}
                            urlImagemBusca={this.state.artigo.imagemBSMais}
                        />
                    </ModalBody>
                </Modal>

                <Modal className="modal-upload-imagem" size="lg" isOpen={this.state.openModalImagemHub} toggle={() => this.toggleModalImagem(null, "Hub")}>
                    <ModalHeader toggle={() => this.toggleModalImagem(null, "Hub")}>
                        Upload de imagem - Hub
                    </ModalHeader>
                    <ModalBody>
                        <ImagesUpload
                            plataforma="Hub"
                            toggle={this.toggleModalImagem}
                            onChangeInput={this.onChangeInput}
                            imgNoTexto={false}
                            alteracao={this.state.temAlteracao}
                            realizaBusca={!!this.state.artigo.imagemHub}
                            urlImagemBusca={this.state.artigo.imagemHub} />
                    </ModalBody>
                </Modal>

                <Modal className="modal-upload-imagem" size="lg" isOpen={this.state.openModalImagemThumbBSMais} toggle={() => this.toggleModalImagem(null, "ThumbBSMais")}>
                    <ModalHeader toggle={() => this.toggleModalImagem(null, "ThumbBSMais")}>
                        Upload de imagem - Thumb BS+
                    </ModalHeader>
                    <ModalBody>
                        <ImagesUpload
                            plataforma="ThumbBSMais"
                            toggle={this.toggleModalImagem}
                            onChangeInput={(e) => this.onChangeInputThumb(e, "thumbBSMais")}
                            imgNoTexto={false}
                            alteracao={this.state.temAlteracao}
                            realizaBusca={!!this.state.artigo.thumbBSMais}
                            urlImagemBusca={this.state.artigo.thumbBSMais}
                        />
                    </ModalBody>
                </Modal>

                <Modal className="modal-upload-imagem" size="lg" isOpen={this.state.openModalImagemThumbHub} toggle={() => this.toggleModalImagem(null, "ThumbHub")}>
                    <ModalHeader toggle={() => this.toggleModalImagem(null, "ThumbHub")}>
                        Upload de imagem - Thumb Hub
                    </ModalHeader>
                    <ModalBody>
                        <ImagesUpload
                            plataforma="ThumbHub"
                            toggle={this.toggleModalImagem}
                            onChangeInput={(e) => this.onChangeInputThumb(e, "thumbHub")}
                            imgNoTexto={false}
                            alteracao={this.state.temAlteracao}
                            realizaBusca={!!this.state.artigo.thumbHub}
                            urlImagemBusca={this.state.artigo.thumbHub}
                        />
                    </ModalBody>
                </Modal>

                <Modal className="modal-upload-imagem" size="lg" isOpen={this.state.openModalImagemDestaque} toggle={this.toggleModalImagemDestaque}>
                    <ModalHeader toggle={this.toggleModalImagemDestaque}>
                        Upload de imagem - Destaque
                    </ModalHeader>
                    <ModalBody>
                        <ImagesUpload
                            toggle={this.toggleModalImagemDestaque}
                            onChangeInput={this.onChangeInputDestaque}
                            alteracao={this.state.temAlteracao} />
                    </ModalBody>
                </Modal>

                <InsertVideo
                    isOpen={this.state.openModalVideo}
                    toggle={this.toggleModalVideo}
                    handleModalVideo={this.handleModalVideo}
                />

                <InsertPodcast
                    isOpen={this.state.openModalPodcast}
                    toggle={this.toggleModalPodcast}
                    handleModalPodcast={this.handleModalPodcast}
                />

                <InsertPlaylist
                    isOpen={this.state.openModalPlaylist}
                    toggle={this.toggleModalPlaylist}
                    handleModalPlaylist={this.handleModalPlaylist}
                />

                <InsertCarrossel
                    isOpen={this.state.openModalCarrossel}
                    toggle={this.toggleModalCarrossel}
                    handleModalCarrossel={this.handleModalCarrossel}
                    imagensIniciais={this.state.carrosselEmEdicaoImagens}
                    editando={!!this.state.carrosselEmEdicaoBlockKey}
                />

                <InsertInstagram
                    isOpen={this.state.openModalInstagram}
                    toggle={this.toggleModalInstagram}
                    handleModalInstagram={this.handleModalInstagram}
                />

                <Modal isOpen={this.state.modalSucessoAlteracao} toggle={this.toggleSucessoAlteracao}>
                    <ModalHeader toggle={this.toggleSucessoAlteracao}>
                        {this.state.novoArtigo ? 'Novo Artigo' : 'Edição de Artigo'}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.novoArtigo ? 'Novo artigo criado com sucesso! :)' : 'Alterações realizadas com sucesso! :)'}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.toggleSucessoAlteracao}>ok</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalExcluirThumb} toggle={() => this.toggleModalExcluirThumb()}>
                    <ModalHeader toggle={() => this.toggleModalExcluirThumb()}>Excluir thumbnail</ModalHeader>
                    <ModalBody>
                        <p>Deseja realmente excluir a {this.state.thumbExcluir ? this.state.thumbExcluir.nome : 'thumbnail'} deste artigo?</p>
                        <p className="m-0"><small>Sem thumbnail, a imagem de capa passa a ser exibida no feed. A alteração só é aplicada ao salvar o artigo.</small></p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.toggleModalExcluirThumb()}>cancelar</Button>
                        <Button color="danger" onClick={this.excluirThumb}>excluir</Button>
                    </ModalFooter>
                </Modal>
                <Modal size="xl" isOpen={this.state.openModalTutorial} toggle={this.toggleModalTutorial}>
                    <ModalHeader toggle={this.toggleModalTutorial}>
                        Tutorial: o que é possível inserir no texto
                    </ModalHeader>
                    <ModalBody>
                        <div className="row no-gutters">
                            <div className="col-12 pb-3">
                                <p className="m-0">
                                    Além da formatação de texto, a barra de ferramentas do campo Texto permite inserir
                                    os conteúdos abaixo. Antes de começar, vale saber:
                                </p>
                            </div>

                            <div className="col-12 pb-4">
                                <ul className="mb-0 pl-4">
                                    {this.tutorialAvisos.map((item, index) => {
                                        return <li key={`tutorial-aviso-${index}`} className="pb-1">{item}</li>
                                    })}
                                </ul>
                            </div>

                            {this.tutorialRecursos.map((item, index) => {
                                return (
                                    <div key={`tutorial-recurso-${index}`} className="col-12 pb-4">
                                        <div className="row no-gutters">
                                            <div className="col-auto pr-3 text-center" style={{ width: 40 }}>
                                                <i className={`${item.icone} fa-lg text-primary`}></i>
                                            </div>
                                            <div className="col">
                                                <p className="m-0"><strong>{item.nome}</strong></p>
                                                <p className="m-0">{item.resumo}</p>
                                                <ul className="mb-0 pl-4">
                                                    {item.passos.map((passo, indexPasso) => {
                                                        return <li key={`tutorial-passo-${index}-${indexPasso}`}>{passo}</li>
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleModalTutorial}>ok</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalPendencia} toggle={this.toggleModalPendencia}>
                    <ModalHeader toggle={this.toggleModalPendencia}>Campos obrigatórios</ModalHeader>
                    <ModalBody>
                        <p>Por favor, preencha o(s) seguinte(s) campo(s) obrigatório(s):</p>
                        <ul>
                            {this.state.pendencias && this.state.pendencias.map((item, index) => {
                                return <li key={`campo-${index}`}>{item.campo}</li>
                            })}
                        </ul>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggleModalPendencia}>ok</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalPub} toggle={this.togglePub}>
                    <ModalHeader toggle={this.togglePub}>Agendar publicação</ModalHeader>
                    <ModalBody>
                        <div className="col-12 px-0 text-center">
                            <p>Selecione a data de agendamento para publicação:</p>
                        </div>
                        <div className="col-12 px-0 text-center">
                            <SingleDatePicker
                                date={this.state.dtPubAux !== null ? moment(this.state.dtPubAux) : null} // momentPropTypes.momentObj or null
                                onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                focused={this.state.focused} // PropTypes.bool
                                onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                id="your_unique_id" // PropTypes.string.isRequired,
                                orientation="horizontal"
                                anchorDirection="right"
                                openDirection="down"
                                verticalHeight={450}
                                numberOfMonths={1}
                                small={true}
                                phrases={this._phrases}
                                placeholder=""
                                isOutsideRange={this._outsideRange}
                                displayFormat="DD/MM/YY"
                            />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="success" onClick={this.salvarAgendamento}>agendar</Button>
                    </ModalFooter>
                </Modal>



                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    // direcionaURL={'/conteudo'}
                    // goBack={true}
                    goBack={!this.state.hasError}
                />

                <ArticlePreviewHK
                    toggle={this.togglePreviewHK}
                    isOpen={this.state.modalPreviewHK}
                    imagem={this.state.artigo.imagemHub}
                    dtPublicacao={this.state.dtPubAux}
                    nomeSecao={!!this.state.artigo.secao ? this.state.artigo.secao.nome : '[Nome da Seção]'}
                    autor={this.state.artigo.autor}
                    titulo={this.state.artigo.titulo}
                    previaDescricao={this.state.previaDescricao}
                    previaTexto={this.state.previaTexto}
                    sigla={this.props.match.params.periodico}
                />

            </div >
        )
    }
}

export default ArticleDetails;